function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterdropBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "237.62 278.99 246.94 280.92 250.11 284.21 254.25 284.84 255.57 288.77 254.6 291.43 251.78 292.72 244.86 291.59 244.68 290.75 247.95 288.47 245.69 284.3 239.5 283.45 236.21 280.63 237.62 278.99",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.18,290a.52.52,0,0,1-.32-.11l-7.06-5.77a.62.62,0,0,1-.14-.18l-2.56-5.71-7.68-4.17L243,271.92,241.38,276a.51.51,0,0,1-.27.27.53.53,0,0,1-.39,0l-4.43-1.91A.52.52,0,0,1,236,274l-1.13-7.08a.51.51,0,0,1,.28-.53l4.42-2.09a.5.5,0,0,1,.5,0l2.48,1.72.48-3.54a.52.52,0,0,1,.37-.42l6.1-1.57a.54.54,0,0,1,.22,0l15.33,3a.54.54,0,0,1,.27.14l3.17,3.29a.53.53,0,0,1,.12.51l-1.27,3.92,2.23,8.13,2.63,3.09a.4.4,0,0,1,.1.18l.92,3.13a.49.49,0,0,1-.29.6L264.36,290A.39.39,0,0,1,264.18,290Zm-6.65-6.58,6.73,5.5,7.87-3.17-.76-2.6-2.63-3.09a.5.5,0,0,1-.1-.19l-2.31-8.38a.53.53,0,0,1,0-.28l1.22-3.79-2.85-3-15.08-3L244,263l-.55,4a.49.49,0,0,1-.29.39.51.51,0,0,1-.49-.05l-2.91-2-3.82,1.81,1,6.43,3.7,1.6,1.67-4.16a.5.5,0,0,1,.31-.29.48.48,0,0,1,.42.05l3.88,2.47,7.81,4.25a.47.47,0,0,1,.21.23Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-16--inject-39)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "277.42 266.15 274.06 266 271.82 268.95 274.67 274.76 277.42 274.14 277.42 266.15",
    style: {
      fill: "#fff",
      clipPath: "url(#freepik--clip-path-2--inject-39)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.67,275.26a.51.51,0,0,1-.45-.28l-2.84-5.81a.49.49,0,0,1,.05-.53l2.23-2.94a.54.54,0,0,1,.42-.19l3.36.14a.5.5,0,0,1,.48.5v8a.49.49,0,0,1-.39.49l-2.75.61ZM272.41,269l2.54,5.18,2-.44v-7.11l-2.62-.11Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-3--inject-39)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "298.01 265.8 289.96 263.58 287.92 261.37 286.36 262.38 288.79 266.29 291.28 271.51 294.74 272.08 295.18 271.09 292.57 268.34 298.55 269.23 298.01 265.8",
    style: {
      fill: "#fff",
      clipPath: "url(#freepik--clip-path-4--inject-39)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.74,272.58h-.09L291.2,272a.51.51,0,0,1-.37-.28l-2.5-5.22-2.39-3.86a.49.49,0,0,1,.15-.68l1.55-1a.5.5,0,0,1,.64.08l2,2.11,7.91,2.17a.52.52,0,0,1,.36.41l.54,3.43a.49.49,0,0,1-.14.43.49.49,0,0,1-.43.15l-4.54-.68,1.62,1.7a.5.5,0,0,1,.09.55l-.45,1A.5.5,0,0,1,294.74,272.58Zm-3.12-1.52,2.82.46.15-.33-2.38-2.51a.49.49,0,0,1-.08-.57.5.5,0,0,1,.52-.27l5.3.8-.39-2.45-7.73-2.12a.61.61,0,0,1-.24-.15l-1.75-1.9-.79.52,2.16,3.49Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-5--inject-39)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "253.16 355.95 252.5 356.99 259.27 357.48 262.47 359.88 266.59 359.42 267.56 356.76 262.5 356.99 253.16 355.95",
    style: {
      fill: "#fff",
      clipPath: "url(#freepik--clip-path-6--inject-39)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.47,360.38a.49.49,0,0,1-.3-.1L259.09,358l-6.63-.48a.5.5,0,0,1-.41-.28.48.48,0,0,1,0-.49l.66-1a.49.49,0,0,1,.47-.23l9.34,1,5-.23a.49.49,0,0,1,.43.2.52.52,0,0,1,.07.47l-1,2.66a.49.49,0,0,1-.41.32l-4.12.47Zm-2.77-3.2,2.91,2.18,3.62-.41.6-1.66-4.31.2Zm-6.33-.63,1.88.14-1.84-.2Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-7--inject-39)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.78,293.22h-.08l-6.92-1.13a.49.49,0,0,1-.4-.39l-.19-.84a.48.48,0,0,1,.2-.52l2.9-2-1.92-3.55-5.94-.81a.42.42,0,0,1-.25-.12l-3.3-2.82a.51.51,0,0,1-.17-.34.48.48,0,0,1,.12-.36l1.41-1.65a.49.49,0,0,1,.48-.16l9.32,1.93a.51.51,0,0,1,.26.14l3,3.17,4,.61a.49.49,0,0,1,.39.34l1.32,3.92a.47.47,0,0,1,0,.33l-1,2.66a.45.45,0,0,1-.26.28l-2.82,1.3A.52.52,0,0,1,251.78,293.22Zm-6.5-2.06,6.43,1,2.49-1.15.84-2.29-1.17-3.48L250,284.7a.53.53,0,0,1-.29-.14l-3.07-3.19-8.87-1.83-.9,1,2.81,2.4,6,.83a.51.51,0,0,1,.37.25l2.26,4.17a.51.51,0,0,1-.16.65l-3,2.09Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path--inject-39)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.69,365l-7.38-1.25-8.92-1.13L289.83,364l-6.42.09-6.45,3-3.76,1.06-2.33.51L267,372.21l-3.86,2.63-6.52-2.32.17-6.26-3.93-.68-4.23.94-1.06-1.77-.42-3.9-2-1.79-2.87,1.08-.37,2.31-3.55,1-4-3.11-2.4-4.8,1.86-6.63,6.24-.94,2,1.1,2.54-.56,2.75-2.61,2.94.24,5.27,5.71,1.44-.54-1.51-4.77-1.83-2.26-.47-4.12,7.08-5.13-.68-8.06,2.77-3.51,1.68-5.48,2-.89,4.16-4.26-.16-1.74-3.34,1-1-1.55-2.33.52L260,312.67l1.08-3.13,6.94-3.76,1.27-2.28,4,4,2.33,1.48,2.77-1.5L276.5,305l-5.15-2.19L265,298.23l-6.09-2.42-5.27.28-3.11-2L247,294l-.24.94.94,6.23,1.32,1.93-.4,7.2-5-2.45,0-3.1-4.92-1.13-2.42-1.91-.12-5.53,5.16-5.81-.71-5.17-2.28.73-1.91-1.58-1.34-3-1.53.11-.09,3.58-2.24.94-2.7-7.17-1.93-.69-3.24-.61-3,2.45,5.13,3.08,1.65,3.41-8.89-4-6.57-4.54-1.69-5.63-5.88-.47-3.62,3.69a32.67,32.67,0,0,1-2.8,2.4,36.51,36.51,0,0,1-4.89,2l-.05,3.79-4.82,1.29.94,2.23,8.11-.47,5,3.56,1.65,7.41-.87,7.08,2,6.89L201,323.32l2.16,15.74,3.88,8.47,4.25,6.16,3.27-.28-1.81-3.15-2.25-2.17-2.1-4.42,1.81-.85,4.66,7,3.62,6.3,1.22,5.51,5.11,4,8.37,3.7,11.67.51,4.09,2.43,3.3,2.82,4.32,1.48,4.94.24,4.61-1.25s.26,2.17.5,3.23-1.93,5.31-1.93,5.31l-1.39,4.75,2.73,4.29,5.08.87,8.07,5.31,3.24.62.71,3.17.7,1.4a91,91,0,0,0,39.76-30.77l-.23-1.56,3.41-11.64-3.18-1.29Z",
    style: {
      fill: "#fff",
      clipPath: "url(#freepik--clip-path-9--inject-39)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.87,405a.49.49,0,0,1-.45-.28l-.7-1.39a.56.56,0,0,1,0-.12l-.63-2.85-2.93-.55a.71.71,0,0,1-.18-.08l-8-5.26-5-.85a.49.49,0,0,1-.33-.23l-2.73-4.28a.49.49,0,0,1-.06-.41l1.39-4.75c1-2,2-4.52,1.92-5.07-.16-.73-.34-2-.43-2.69l-4.06,1.09a.26.26,0,0,1-.15,0l-4.94-.24-.14,0-4.33-1.49a.51.51,0,0,1-.16-.09l-3.29-2.82-3.92-2.31-11.54-.52a.39.39,0,0,1-.18,0L224.66,366l-.11-.06-5.1-4a.47.47,0,0,1-.18-.29l-1.21-5.43L214.48,350l-4.4-6.58-1,.45,1.84,3.88,2.19,2.1.09.12,1.81,3.15a.51.51,0,0,1,0,.48.52.52,0,0,1-.4.27l-3.27.28a.53.53,0,0,1-.46-.22l-4.25-6.16-3.93-8.54a1,1,0,0,1,0-.14l-2.16-15.74a.55.55,0,0,1,0-.22l3.58-11.55-1.94-6.74a.69.69,0,0,1,0-.2l.86-7-1.59-7.14-4.7-3.34-7.95.46a.5.5,0,0,1-.49-.3l-.94-2.24a.49.49,0,0,1,0-.41.47.47,0,0,1,.32-.26l4.45-1.2,0-3.41a.49.49,0,0,1,.35-.46,35.34,35.34,0,0,0,4.77-1.92,31.26,31.26,0,0,0,2.73-2.35l3.61-3.68a.54.54,0,0,1,.4-.15l5.88.48a.48.48,0,0,1,.44.35l1.64,5.45,6.42,4.45,7.56,3.41-1-2-5-3a.5.5,0,0,1-.24-.4.46.46,0,0,1,.18-.42l3-2.45a.49.49,0,0,1,.41-.1l3.24.61,2,.7a.5.5,0,0,1,.3.3l2.52,6.69,1.46-.62.08-3.25a.5.5,0,0,1,.47-.48l1.52-.12a.49.49,0,0,1,.5.29l1.29,2.93,1.61,1.33,2-.65a.52.52,0,0,1,.42.06.5.5,0,0,1,.23.35l.7,5.18a.49.49,0,0,1-.12.4l-5,5.66.1,5.09,2.15,1.7,4.81,1.1a.49.49,0,0,1,.39.48l0,2.8,4,2,.35-6.28-1.22-1.79a.5.5,0,0,1-.08-.2l-.94-6.24a.41.41,0,0,1,0-.19l.23-.94a.52.52,0,0,1,.5-.38l3.58.09a.57.57,0,0,1,.25.08l3,1.89,5.11-.27a.51.51,0,0,1,.21,0l6.09,2.43a.24.24,0,0,1,.11.06l6.31,4.55,5.1,2.17a.43.43,0,0,1,.2.15l1.88,2.47a.51.51,0,0,1,.09.41.49.49,0,0,1-.25.34l-2.78,1.5a.48.48,0,0,1-.5,0L273,307.92l-.09-.07-3.53-3.53-.94,1.71a.52.52,0,0,1-.2.19l-6.77,3.67-.63,1.81,2.33-1.12.11,0,2.33-.52a.51.51,0,0,1,.53.22l.8,1.24,3-.86a.48.48,0,0,1,.42.07.51.51,0,0,1,.22.36l.16,1.74a.53.53,0,0,1-.14.4l-4.16,4.26a.54.54,0,0,1-.16.1l-1.81.81-1.61,5.26a.8.8,0,0,1-.08.16l-2.66,3.35.67,7.87a.52.52,0,0,1-.21.45l-6.84,4.95.42,3.68,1.74,2.15a.56.56,0,0,1,.09.17l1.5,4.77a.5.5,0,0,1-.3.62l-1.43.54a.51.51,0,0,1-.55-.13l-5.13-5.57-2.52-.2-2.6,2.45a.41.41,0,0,1-.23.13l-2.54.56a.48.48,0,0,1-.35-.05l-1.87-1-5.75.86-1.72,6.14,2.26,4.52,3.73,2.89,3-.86.33-2a.51.51,0,0,1,.32-.39l2.87-1.08a.5.5,0,0,1,.51.1l1.95,1.79a.47.47,0,0,1,.16.31l.41,3.8.82,1.36,3.88-.86a.45.45,0,0,1,.2,0l3.93.69a.49.49,0,0,1,.41.5l-.16,5.9,5.94,2.12,3.65-2.49,3.82-3.49a.57.57,0,0,1,.23-.12l2.33-.51,3.74-1.05,6.37-3a.46.46,0,0,1,.2-.05l6.37-.09,6.51-1.45h.18l8.91,1.14,7.24,1.22,10.79-5.68a.52.52,0,0,1,.42,0L327,360a.51.51,0,0,1,.29.6l-3.38,11.54.21,1.45a.49.49,0,0,1-.09.37,91.53,91.53,0,0,1-40,30.93A.39.39,0,0,1,283.87,405Zm-.23-2.07.47.93a90.55,90.55,0,0,0,39-30.26l-.2-1.35a.55.55,0,0,1,0-.22l3.28-11.21-2.54-1-10.73,5.65a.51.51,0,0,1-.32.05l-7.39-1.25-8.8-1.11-6.48,1.44h-.1l-6.32.09-6.35,2.94-3.84,1.09-2.22.49-3.79,3.44-3.91,2.68a.51.51,0,0,1-.45.06L256.45,373a.52.52,0,0,1-.34-.49l.16-5.82-3.41-.6-4.13.92a.49.49,0,0,1-.54-.23L247.13,365a.48.48,0,0,1-.07-.21l-.4-3.71-1.59-1.46-2.31.88-.33,2a.51.51,0,0,1-.36.4l-3.55,1a.5.5,0,0,1-.44-.09l-4-3.1a.49.49,0,0,1-.14-.18l-2.4-4.79a.51.51,0,0,1,0-.36l1.86-6.64a.51.51,0,0,1,.41-.36l6.23-.94a.59.59,0,0,1,.32.06l1.86,1,2.22-.5,2.65-2.51a.49.49,0,0,1,.38-.14l2.94.24a.46.46,0,0,1,.33.16l5,5.47.68-.26-1.34-4.23-1.77-2.19a.47.47,0,0,1-.11-.26l-.47-4.11a.5.5,0,0,1,.2-.46l6.86-5-.66-7.78a.52.52,0,0,1,.11-.36l2.71-3.43,1.65-5.39a.52.52,0,0,1,.27-.31l1.94-.85,3.93-4-.08-.91-2.76.79a.5.5,0,0,1-.56-.21l-.82-1.26-1.94.43-3.36,1.62a.5.5,0,0,1-.55-.07.52.52,0,0,1-.14-.54l1.09-3.13a.47.47,0,0,1,.23-.27l6.81-3.7,1.2-2.15a.53.53,0,0,1,.37-.26.53.53,0,0,1,.42.15l4,4,2,1.29,2-1.08-1.45-1.9-5-2.14-.09-.06-6.3-4.55-5.94-2.36-5.16.28a.44.44,0,0,1-.29-.08l-3-1.9-3-.08-.11.45.91,6,1.25,1.84a.56.56,0,0,1,.09.31l-.4,7.2a.51.51,0,0,1-.72.42l-5-2.45a.49.49,0,0,1-.28-.44l0-2.71-4.53-1.05a.4.4,0,0,1-.2-.09l-2.42-1.91a.47.47,0,0,1-.19-.38l-.12-5.53a.55.55,0,0,1,.13-.34l5-5.64-.59-4.35-1.72.54a.47.47,0,0,1-.47-.09l-1.91-1.57a.5.5,0,0,1-.13-.19l-1.2-2.71-.73.06-.08,3.12a.52.52,0,0,1-.31.45l-2.23.94a.48.48,0,0,1-.39,0,.47.47,0,0,1-.27-.28l-2.63-7-1.71-.61-2.94-.54-2.28,1.85,4.52,2.71a.48.48,0,0,1,.19.21l1.65,3.41a.52.52,0,0,1-.09.57.53.53,0,0,1-.57.11l-8.89-4-6.64-4.58a.52.52,0,0,1-.19-.27l-1.6-5.3-5.31-.42-3.46,3.53a33.27,33.27,0,0,1-2.87,2.46,31.23,31.23,0,0,1-4.68,1.92l0,3.43a.52.52,0,0,1-.37.48l-4.27,1.14.58,1.38,7.76-.44a.45.45,0,0,1,.32.09l5,3.55a.52.52,0,0,1,.2.3l1.65,7.41a.48.48,0,0,1,0,.17l-.86,7,1.95,6.79a.48.48,0,0,1,0,.29l-3.59,11.58,2.13,15.56,3.85,8.4,4.05,5.85,2.2-.19-1.38-2.41-2.21-2.12a.76.76,0,0,1-.11-.14L208,343.88a.5.5,0,0,1,0-.38.48.48,0,0,1,.26-.28l1.81-.85a.51.51,0,0,1,.63.17l4.66,7,3.64,6.33a.78.78,0,0,1,.05.14l1.18,5.33,4.92,3.83,8.23,3.63,11.57.52a.46.46,0,0,1,.23.06l4.1,2.43,3.29,2.81,4.17,1.43,4.79.23L266,375a.5.5,0,0,1,.41.07.51.51,0,0,1,.22.35s.26,2.16.49,3.18-1.45,4.61-2,5.65l-1.29,4.45,2.49,3.9,4.86.83a.41.41,0,0,1,.19.08l8,5.26,3.14.59a.5.5,0,0,1,.4.39Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-10--inject-39)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-12--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.14,276.43l-3.22-3.5-4-4-2.26-6.17,4-.21-.26-2.16-2.8.4,2.09-1.58,2.21-2-.47-2.12-3.29-2.82-1.55-4.44a91.43,91.43,0,0,0-110.33-2.12l5.65,2.38-2.12,4.47-3.83,1.74.84,5.81-1.55,1-1.6,2.8,1.06,3.76,3.69-.38-.68,3.93,3.6-.8,4.4-9.19-.12-3.53,5.84-1.74.91-2.87,6-2-.16-3.74,4.4-1.2a22.94,22.94,0,0,1,3.43-2.54,26.62,26.62,0,0,1,3.84.26l3.74,1.84,4.44-1,3.3-3.18,5-.65a5.35,5.35,0,0,0,2.52.32c1.05-.23,3.9-2.42,3.9-2.42l7,2.45,3,1.34.71,3.18,3.27-.28.63-2.15,3,.66.16,1.74-6,3.11,4.64,3.86,8.56,2.54,4.12,3.53,4.75-.61.59-2.36,1.6-.79-6.45-3-3.48.33,2.56-1.46-3.34-3,3.56-1,5.22,1.5,2.19,4.85,2.94,2.24,3.26,5.71,5.41,2.36,1.56,7,5.57,2.1.31,2.37,0,2.9,2.12,3.52.85,1.82,3.74-.17.89-4Z",
    style: {
      fill: "#fff",
      clipPath: "url(#freepik--clip-path-11--inject-39)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-13--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311,283.64a.51.51,0,0,1-.45-.29l-.84-1.81-2.1-3.49a.59.59,0,0,1-.07-.26l0-2.89-.27-2-5.29-2a.47.47,0,0,1-.31-.36l-1.5-6.74L295,261.55a.52.52,0,0,1-.23-.21l-3.22-5.63-2.86-2.17a.55.55,0,0,1-.15-.19l-2.09-4.64-4.86-1.4L279,248l2.67,2.43a.5.5,0,0,1,.16.43.51.51,0,0,1-.25.38l-.54.31,1.16-.12a.58.58,0,0,1,.26,0l6.45,3a.53.53,0,0,1,.29.45.5.5,0,0,1-.28.45l-1.39.7-.54,2.13a.48.48,0,0,1-.42.37l-4.75.61a.5.5,0,0,1-.39-.11l-4-3.46L269,253.15a.52.52,0,0,1-.18-.1l-4.63-3.86a.49.49,0,0,1-.18-.44.53.53,0,0,1,.26-.39l5.68-2.94-.1-1-2.22-.49-.5,1.7a.5.5,0,0,1-.44.35l-3.27.29a.5.5,0,0,1-.53-.39l-.65-2.94-2.74-1.23-6.69-2.35a16.39,16.39,0,0,1-3.89,2.35,5.51,5.51,0,0,1-2.68-.3l-4.68.62-3.17,3.06a.56.56,0,0,1-.24.13l-4.45,1a.4.4,0,0,1-.32,0l-3.67-1.79a21.88,21.88,0,0,0-3.58-.26,22.17,22.17,0,0,0-3.22,2.43.44.44,0,0,1-.19.1l-4,1.1.14,3.34a.52.52,0,0,1-.34.5l-5.76,1.91-.84,2.63a.5.5,0,0,1-.33.33L206.07,258l.11,3.14a.59.59,0,0,1-.05.23l-4.4,9.2a.49.49,0,0,1-.34.27l-3.6.8a.49.49,0,0,1-.46-.13.48.48,0,0,1-.14-.44l.57-3.28-3,.31a.5.5,0,0,1-.53-.36L193.13,264a.46.46,0,0,1,.05-.38l1.6-2.8a.44.44,0,0,1,.16-.17l1.28-.84-.8-5.49a.51.51,0,0,1,.29-.53l3.67-1.66,1.81-3.83L196,246.13a.49.49,0,0,1-.1-.86,91.93,91.93,0,0,1,110.92,2.13.46.46,0,0,1,.17.22l1.51,4.31,3.19,2.74a.47.47,0,0,1,.16.27l.47,2.12a.49.49,0,0,1-.15.47L310,259.58l-.58.44.88-.13a.55.55,0,0,1,.37.1.47.47,0,0,1,.19.34l.26,2.16a.5.5,0,0,1-.11.39.53.53,0,0,1-.36.17l-3.27.18,2,5.42,3.92,3.92,3.24,3.52a.52.52,0,0,1,.12.45l-.54,2.56-.9,4a.5.5,0,0,1-.46.39l-3.74.17Zm-2.46-6,2.05,3.41.73,1.55,3-.13,1.3-5.91-3.05-3.32-4-4a.57.57,0,0,1-.12-.18l-2.26-6.16a.51.51,0,0,1,.06-.45.5.5,0,0,1,.39-.23l3.42-.18-.14-1.12-2.29.32a.5.5,0,0,1-.53-.3.49.49,0,0,1,.16-.59l2.09-1.58,2-1.82-.37-1.67-3.17-2.71a.64.64,0,0,1-.14-.22l-1.51-4.3a90.91,90.91,0,0,0-108.88-2.53l4.82,2a.48.48,0,0,1,.26.67l-2.12,4.47a.47.47,0,0,1-.24.24l-3.49,1.59.79,5.43a.51.51,0,0,1-.22.5l-1.45.94-1.44,2.51.89,3.16,3.27-.33a.5.5,0,0,1,.42.15.53.53,0,0,1,.13.43l-.56,3.19,2.63-.58,4.24-8.87-.11-3.4a.5.5,0,0,1,.36-.5l5.58-1.66.84-2.62a.48.48,0,0,1,.32-.33l5.64-1.87-.15-3.37a.49.49,0,0,1,.37-.5l4.29-1.17a17.63,17.63,0,0,1,3.56-2.58,24.68,24.68,0,0,1,4,.25l.16,0,3.58,1.76,4.14-.92,3.19-3.08a.49.49,0,0,1,.28-.13l5-.66a.52.52,0,0,1,.25,0,4.86,4.86,0,0,0,2.23.31,17.76,17.76,0,0,0,3.71-2.33.5.5,0,0,1,.47-.08l7,2.45,3,1.36a.48.48,0,0,1,.28.34l.61,2.75,2.49-.21.54-1.82a.5.5,0,0,1,.59-.34l3,.66a.49.49,0,0,1,.39.44l.17,1.74a.51.51,0,0,1-.27.49l-5.31,2.76,4,3.31,8.46,2.51a.5.5,0,0,1,.19.1l3.94,3.38,4.2-.54.5-2a.49.49,0,0,1,.26-.32l.68-.34-5.39-2.52-3.34.32a.51.51,0,0,1-.53-.35.5.5,0,0,1,.23-.58l2-1.12-2.83-2.57a.5.5,0,0,1,.2-.85l3.55-1a.45.45,0,0,1,.28,0l5.22,1.5a.51.51,0,0,1,.31.28l2.14,4.73,2.84,2.16a.47.47,0,0,1,.13.15l3.19,5.57,5.25,2.29a.47.47,0,0,1,.29.35l1.49,6.72,5.33,2a.51.51,0,0,1,.32.4l.3,2.38Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-12--inject-39)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-14--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.16,254.49l.27,1.22-.31,3.62,1.29,2.82,2.52.33.89,4-2.77-.5,1.9,11.58-1.5,5.22,3,5.55,3.31,1.93,2.54,11.43L330,310l4.47,6.12,5.15.19.75-4.61.57-.7a91.67,91.67,0,0,0-26.82-56.51Z",
    style: {
      fill: "#fff",
      clipPath: "url(#freepik--clip-path-13--inject-39)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-15--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.66,316.81h0l-5.15-.19a.51.51,0,0,1-.39-.21l-4.47-6.11L324.88,302a.42.42,0,0,1-.06-.14l-2.49-11.22-3.12-1.82a.5.5,0,0,1-.19-.19L316,283a.48.48,0,0,1-.05-.37l1.48-5.12-1.89-11.46a.49.49,0,0,1,.15-.43.48.48,0,0,1,.44-.14l2,.36-.65-2.95-2.17-.28a.49.49,0,0,1-.39-.29l-1.29-2.82a.45.45,0,0,1-.05-.25l.3-3.55-.25-1.14a.5.5,0,0,1,.24-.55.52.52,0,0,1,.6.09,92.12,92.12,0,0,1,27,56.82.52.52,0,0,1-.11.36l-.49.59-.73,4.48A.5.5,0,0,1,339.66,316.81Zm-4.89-1.18,4.47.16.68-4.17a.44.44,0,0,1,.11-.24l.43-.53a91.58,91.58,0,0,0-1.74-11A90.56,90.56,0,0,0,314.91,256l-.28,3.29,1.12,2.45,2.25.3a.5.5,0,0,1,.42.39l.89,4a.49.49,0,0,1-.12.45.51.51,0,0,1-.45.15l-2.08-.37,1.79,10.87a.53.53,0,0,1,0,.22l-1.45,5,2.85,5.25,3.19,1.86a.49.49,0,0,1,.24.32l2.52,11.36,4.69,8.21Z",
    style: {
      fill: "#263238",
      clipPath: "url(#freepik--clip-path-14--inject-39)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-16--inject-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "264.96 264.03 249.62 260.99 243.53 262.57 242.94 266.92 239.79 264.73 235.36 266.82 236.49 273.9 240.91 275.81 242.77 271.18 246.66 273.65 254.49 277.9 257.12 283.76 264.18 289.53 272.74 286.07 271.82 282.94 269.12 279.77 266.81 271.39 268.13 267.32 264.96 264.03",
    style: {
      fill: "#fff",
      clipPath: "url(#freepik--clip-path-15--inject-39)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.7,232.51c-5,42-24.13,90.8-62.42,113.22-57.84,33.89-53,86-165.91,108.68a232,232,0,0,1-50.06,4.72,192.54,192.54,0,0,1-24.57-2C100,446.65,51.69,396.77,34,336.56c-23.32-79.19,23.24-131,54.1-162.27S141.52,45.73,252.35,22.58a225.06,225.06,0,0,1,51.45-4.89c39.43,1,82.44,13.91,112.2,40.94q3.35,3,6.52,6.3C463.88,107.39,481.46,175.28,474.7,232.51Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.7,232.51c-5,42-24.13,90.8-62.42,113.22-57.84,33.89-53,86-165.91,108.68a232,232,0,0,1-50.06,4.72,192.54,192.54,0,0,1-24.57-2C100,446.65,51.69,396.77,34,336.56c-23.32-79.19,23.24-131,54.1-162.27S141.52,45.73,252.35,22.58a225.06,225.06,0,0,1,51.45-4.89c39.43,1,82.44,13.91,112.2,40.94q3.35,3,6.52,6.3C463.88,107.39,481.46,175.28,474.7,232.51Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.57,461.86a.61.61,0,0,1-.34-.75A77.43,77.43,0,0,1,98.85,410a.62.62,0,0,1,.73.46.61.61,0,0,1-.45.73,76.19,76.19,0,0,0-54.74,50.27.62.62,0,0,1-.77.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,445.56c-5.75-4.76-14.85,3.13-14.71,3.41-.64,1.1-1.26,2.23-1.85,3.38,1.26-1.17,5.43-1.83,10.92-.6C63.84,452.76,69.64,449.88,64,445.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.79,432.61c-5.81-4.46-8.64,5.22-4.86,9.73,3.57,4.55,5.49,8.26,5.41,10,.52-1.18,1.06-2.35,1.63-3.51C48.68,448.76,52.12,437,46.79,432.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.37,437.31c-4.87-5.64-15.09.51-15,.79q-1.22,1.45-2.37,3c1.43-.91,5.63-.82,10.81,1.33C70,444.35,76.21,442.53,71.37,437.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.58,421.66c-5-5.37-9.34,3.63-6.35,8.69,2.76,5.06,4.05,9,3.69,10.66.7-1.07,1.42-2.11,2.17-3.14C55.81,437.8,61.1,426.93,56.58,421.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,430.45c-3.86-6.37-14.93-2.05-14.87-1.76-1,.81-1.9,1.65-2.81,2.51,1.55-.65,5.66.16,10.4,3.15C77.5,437.16,83.88,436.4,80,430.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,412.54c-4-6.12-9.79,2-7.68,7.49,1.88,5.44,2.49,9.54,1.88,11.09q1.29-1.38,2.64-2.7C64.59,428.31,71.59,418.5,68,412.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.64,425.11c-2.75-6.92-14.4-4.5-14.39-4.21-1.08.64-2.14,1.31-3.19,2,1.64-.38,5.55,1.11,9.73,4.85C86.05,431.33,92.48,431.63,89.64,425.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.85,405.45c-2.93-6.7-10,.36-8.86,6.11,1,5.69.87,9.83,0,11.25,1-.76,2-1.5,3-2.22C74.8,420.44,83.35,411.93,80.85,405.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.14,421.45c-1.55-7.29-13.54-6.84-13.56-6.55-1.18.45-2.34.94-3.49,1.45,1.68-.1,5.3,2,8.8,6.4C95.49,427,101.83,428.35,100.14,421.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8,400.58c-1.77-7.1-10-1.31-9.85,4.56,0,5.77-.82,9.85-1.91,11.11,1.11-.59,2.25-1.15,3.39-1.69C86.2,414.37,96.16,407.39,94.8,400.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.38,412.14c-.17-.1,8.87-6.19,14.76-7.15,5.76-1.11,8,2.95,7,5.33s-5,3-8.39,2.81C103.39,412.66,93.43,412,93.38,412.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.23,412.51l0,0a.42.42,0,0,1-.2-.43.06.06,0,0,1,0,0,.31.31,0,0,1,.21-.25c1.45-1.39,9.82-6.35,14.88-7.18,2.83-.54,5.26.1,6.65,1.78a4.16,4.16,0,0,1,.79,4.1c-1.23,3.25-7,3.17-8.78,3.07-3.29-.46-12.36-1.09-13.22-1A.41.41,0,0,1,93.23,412.51Zm19.13-6.88a7.25,7.25,0,0,0-4.14-.24c-4.65.76-11.2,4.7-13.61,6.33.85,0,2.18.12,4.25.27,2.66.19,6.15.49,8,.74,3.28.19,7.12-.37,8-2.56a3.35,3.35,0,0,0-.67-3.28A4.36,4.36,0,0,0,112.36,405.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.25,463.31a1,1,0,0,1-1-.88A120.07,120.07,0,0,1,85.79,356.29a.94.94,0,1,1,1.1,1.53,118.18,118.18,0,0,0-48.7,104.47,1,1,0,0,1-.87,1Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.87,427.84c-11-3.41-19.43,13.28-19.06,13.6q-.41,3-.65,5.94c1.12-2.42,6.7-5.83,15.29-7.32C60.91,438.27,67.52,430.7,56.87,427.84Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.53,419.47c-11-3-9.29,12.6-1.19,16.83,7.8,4.41,12.75,8.58,13.65,11.07,0-2,.12-4,.25-6C36.81,441.5,34.8,422.66,24.53,419.47Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.56,411.66c-10.32-5.2-21.33,9.66-21,10-.59,1.86-1.13,3.75-1.63,5.65,1.51-2.15,7.58-4.51,16.29-4.49C64.82,422.54,72.58,416.27,62.56,411.66Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.09,398c-10.31-4.74-11.24,10.74-4,16.23,7,5.62,11.14,10.52,11.61,13.09.36-1.94.78-3.86,1.24-5.78C40.54,421.57,41.68,402.85,32.09,398Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.84,396.72c-9.31-6.84-22.61,5.91-22.37,6.29q-1.34,2.6-2.54,5.26c1.84-1.85,8.21-3.13,16.78-1.64C71.26,407.81,79.94,403,70.84,396.72Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.09,378.13c-9.37-6.4-12.85,8.68-6.58,15.28,5.92,6.7,9.23,12.2,9.27,14.79q1-2.74,2.17-5.44C47.51,402.76,51.73,384.56,43.09,378.13Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.52,383.35c-8-8.29-23.31,2.08-23.12,2.48-1.17,1.56-2.29,3.15-3.38,4.76,2.12-1.51,8.61-1.7,16.81,1.2C80.06,394.39,89.45,391,81.52,383.35Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.28,360.38c-8.17-7.88-14.16,6.44-9.07,14,4.71,7.59,7.06,13.56,6.67,16.12q1.45-2.53,3-5C57.48,385.45,64.7,368.17,57.28,360.38Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.41,371.88c-6.55-9.53-23.45-1.78-23.32-1.35q-2.13,2-4.15,4.14c2.35-1.14,8.79-.26,16.4,4C91,382.57,100.92,380.78,94.41,371.88Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.39,345.14C67.66,336,59.23,349.2,63,357.51c3.37,8.29,4.67,14.59,3.85,17.05,1.24-1.51,2.53-3,3.86-4.43C70.23,370,80.37,354.09,74.39,345.14Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2,362.54c-.3,0,9.06-14.12,16.93-19,7.6-5,13.15-.49,13.2,3.49S104,354.31,99,356C93.87,357.36,79.17,362.26,79.2,362.54Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2,363.17h-.08a.64.64,0,0,1-.54-.5.11.11,0,0,1,0-.06.45.45,0,0,1,.14-.47C80,359.27,89,347.2,95.8,343c3.74-2.46,7.6-3,10.59-1.39A6.46,6.46,0,0,1,110,347c.15,5.4-8.21,8.71-10.78,9.6-5,1.29-18.36,5.75-19.55,6.37A.67.67,0,0,1,79.2,363.17ZM102.56,342a11.12,11.12,0,0,0-6.08,2.11c-6.21,3.83-13.27,13.37-15.77,17.12,1.25-.46,3.2-1.12,6.25-2.13,3.94-1.3,9.12-2.94,11.86-3.65,4.82-1.66,10-4.75,9.88-8.37a5.16,5.16,0,0,0-2.91-4.31A6.64,6.64,0,0,0,102.56,342Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.74,461.86a.61.61,0,0,0,.35-.75A77.46,77.46,0,0,0,401.46,410a.61.61,0,0,0-.27,1.19,76.21,76.21,0,0,1,54.74,50.27.61.61,0,0,0,.77.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.32,445.56c5.74-4.76,14.84,3.13,14.7,3.41.64,1.1,1.26,2.23,1.85,3.38-1.26-1.17-5.43-1.83-10.91-.6C436.48,452.76,430.67,449.88,436.32,445.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.53,432.61c5.8-4.46,8.64,5.22,4.85,9.73-3.57,4.55-5.49,8.26-5.41,10q-.77-1.77-1.62-3.51C451.63,448.76,448.19,437,453.53,432.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.94,437.31c4.87-5.64,15.09.51,15,.79q1.23,1.45,2.37,3c-1.43-.91-5.63-.82-10.81,1.33C430.27,444.35,424.11,442.53,428.94,437.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.73,421.66c5-5.37,9.34,3.63,6.35,8.69-2.76,5.06-4,9-3.69,10.66-.7-1.07-1.42-2.11-2.16-3.14C444.5,437.8,439.21,426.93,443.73,421.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.33,430.45c3.86-6.37,14.93-2.05,14.88-1.76,1,.81,1.89,1.65,2.81,2.51-1.56-.65-5.67.16-10.41,3.15C422.81,437.16,416.44,436.4,420.33,430.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.29,412.54c4-6.12,9.8,2,7.69,7.49-1.89,5.44-2.5,9.54-1.89,11.09q-1.27-1.38-2.64-2.7C435.72,428.31,428.72,418.5,432.29,412.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.67,425.11c2.76-6.92,14.41-4.5,14.39-4.21,1.08.64,2.14,1.31,3.19,2-1.64-.38-5.55,1.11-9.73,4.85C414.26,431.33,407.84,431.63,410.67,425.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.46,405.45c2.94-6.7,10,.36,8.86,6.11-.95,5.69-.87,9.83,0,11.25-1-.76-2-1.5-3.05-2.22C425.52,420.44,417,411.93,419.46,405.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.17,421.45c1.56-7.29,13.54-6.84,13.57-6.55,1.17.45,2.33.94,3.48,1.45-1.67-.1-5.3,2-8.79,6.4C404.82,427,398.48,428.35,400.17,421.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.52,400.58c1.76-7.1,10-1.31,9.84,4.56,0,5.77.82,9.85,1.91,11.11-1.11-.59-2.24-1.15-3.39-1.69C414.12,414.37,404.16,407.39,405.52,400.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.93,412.14c.17-.1-8.87-6.19-14.76-7.15-5.76-1.11-8,2.95-7,5.33s5,3,8.39,2.81C396.92,412.66,406.88,412,406.93,412.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.09,412.51l0,0a.4.4,0,0,0,.2-.43.06.06,0,0,0,0,0,.31.31,0,0,0-.2-.25c-1.46-1.39-9.82-6.35-14.88-7.18-2.84-.54-5.27.1-6.65,1.78a4.14,4.14,0,0,0-.8,4.1c1.24,3.25,7,3.17,8.78,3.07,3.29-.46,12.36-1.09,13.23-1A.42.42,0,0,0,407.09,412.51ZM388,405.63a7.25,7.25,0,0,1,4.14-.24c4.65.76,11.21,4.7,13.61,6.33-.85,0-2.17.12-4.24.27-2.67.19-6.16.49-8,.74-3.28.19-7.12-.37-7.95-2.56a3.35,3.35,0,0,1,.67-3.28A4.36,4.36,0,0,1,388,405.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.07,463.31a1,1,0,0,0,.94-.88,120,120,0,0,0-49.49-106.14.94.94,0,1,0-1.1,1.53,118.18,118.18,0,0,1,48.7,104.47,1,1,0,0,0,.87,1Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.44,427.84c11.06-3.41,19.43,13.28,19.06,13.6q.4,3,.66,5.94c-1.13-2.42-6.71-5.83-15.3-7.32C439.4,438.27,432.79,430.7,443.44,427.84Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.78,419.47c11-3,9.3,12.6,1.19,16.83-7.8,4.41-12.75,8.58-13.65,11.07q0-3-.25-6C463.5,441.5,465.51,422.66,475.78,419.47Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.75,411.66c10.32-5.2,21.33,9.66,21,10,.59,1.86,1.13,3.75,1.63,5.65-1.51-2.15-7.58-4.51-16.28-4.49C435.5,422.54,427.74,416.27,437.75,411.66Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.22,398c10.31-4.74,11.24,10.74,4,16.23-6.95,5.62-11.13,10.52-11.6,13.09-.37-1.94-.79-3.86-1.25-5.78C459.77,421.57,458.63,402.85,468.22,398Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.47,396.72c9.31-6.84,22.61,5.91,22.37,6.29q1.34,2.6,2.54,5.26c-1.84-1.85-8.21-3.13-16.78-1.64C429.05,407.81,420.37,403,429.47,396.72Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.22,378.13c9.37-6.4,12.85,8.68,6.59,15.28-5.92,6.7-9.23,12.2-9.27,14.79q-1-2.74-2.18-5.44C452.8,402.76,448.58,384.56,457.22,378.13Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.79,383.35c8-8.29,23.31,2.08,23.12,2.48q1.75,2.34,3.38,4.76c-2.12-1.51-8.61-1.7-16.81,1.2C420.26,394.39,410.86,391,418.79,383.35Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,360.38c8.18-7.88,14.16,6.44,9.08,14-4.72,7.59-7.07,13.56-6.68,16.12q-1.46-2.53-3.05-5C442.83,385.45,435.61,368.17,443,360.38Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.91,371.88c6.54-9.53,23.45-1.78,23.32-1.35q2.11,2,4.14,4.14c-2.35-1.14-8.79-.26-16.4,4C409.29,382.57,399.4,380.78,405.91,371.88Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.92,345.14c6.73-9.14,15.16,4.06,11.42,12.37-3.36,8.29-4.66,14.59-3.84,17.05-1.25-1.51-2.54-3-3.87-4.43C430.09,370,419.94,354.09,425.92,345.14Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.11,362.54c.3,0-9.06-14.12-16.93-19-7.6-5-13.15-.49-13.2,3.49s5.33,7.26,10.36,9C406.44,357.36,421.14,362.26,421.11,362.54Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.11,363.17h.08a.62.62,0,0,0,.54-.5s0,0,0-.06a.45.45,0,0,0-.15-.47c-1.26-2.86-10.31-14.93-17.08-19.11-3.74-2.46-7.6-3-10.58-1.39a6.47,6.47,0,0,0-3.58,5.41c-.15,5.4,8.21,8.71,10.78,9.6,5,1.29,18.36,5.75,19.56,6.37A.63.63,0,0,0,421.11,363.17ZM397.75,342a11.1,11.1,0,0,1,6.08,2.11c6.21,3.83,13.28,13.37,15.77,17.12-1.24-.46-3.2-1.12-6.25-2.13-3.94-1.3-9.12-2.94-11.86-3.65-4.81-1.66-10-4.75-9.88-8.37a5.16,5.16,0,0,1,2.91-4.31A6.67,6.67,0,0,1,397.75,342Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.89,71.41a.77.77,0,0,1,1.05-.15,99.39,99.39,0,0,1,42.12,87.32.79.79,0,0,1-1.57-.1A97.81,97.81,0,0,0,22,72.54a.78.78,0,0,1-.19-1.09S21.87,71.42,21.89,71.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.34,102.56c8-5.3,1.66-19.41,1.27-19.34q-1.68-1.8-3.47-3.53c1,2,.23,7.35-3.31,13.64C25.54,99.69,26.93,107.89,34.34,102.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.64,86.22c7.64-5.48-3.2-12.56-10.16-9.58-6.91,2.69-12.18,3.68-14.25,3q1.91,1.6,3.71,3.3C36.1,82.55,49.22,91.13,56.64,86.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.73,114.68c8.74-3.89,5-18.73,4.6-18.72q-1.34-2-2.77-4c.59,2.1-1.08,7.22-5.65,12.8C33.58,110.43,33.53,118.69,41.73,114.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.46,102.32c8.45-4.12-1-12.83-8.32-11-7.25,1.51-12.58,1.62-14.47.58,1,1.25,2.06,2.52,3,3.82C46.91,95.38,58.31,105.91,66.46,102.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,127.82c9.26-2.39,8.06-17.59,7.69-17.64q-1-2.21-2-4.38c.22,2.15-2.3,6.9-7.74,11.62C39.64,122.27,38.21,130.39,47,127.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.42,119.77c9-2.66,1.17-12.79-6.35-12.23-7.39.29-12.65-.47-14.33-1.81q1.23,2.1,2.34,4.25C55.32,109.69,64.77,121.93,73.42,119.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.94,141.66c9.53-.81,10.88-16,10.52-16.12-.38-1.56-.81-3.11-1.27-4.65C59,123,55.77,127.3,49.61,131,43.64,134.94,40.87,142.73,49.94,141.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.37,138.16c9.33-1.11,3.28-12.45-4.22-13.15-7.34-1-12.4-2.58-13.83-4.17q.85,2.26,1.6,4.57C61.2,125.16,68.48,138.83,77.37,138.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.55,155.93c9.53.8,13.42-14.1,13.08-14.24-.12-1.61-.28-3.22-.48-4.82-.5,2.1-4.44,5.76-11.14,8.43C45.47,148.16,41.43,155.44,50.55,155.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.17,157.11c9.39.47,5.34-11.84-2-13.8-7.07-2.19-11.79-4.65-12.94-6.47.31,1.59.59,3.19.82,4.8C64.42,141.42,69.3,156.25,78.17,157.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5,151.08c.18-.18,4.3,13.2,3.29,20.79-.77,7.49-6.57,8.68-9.14,6.63s-1.87-7.21-.34-11.35C60.14,163.19,64.69,151.2,64.5,151.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.09,150.75l0-.05a.53.53,0,0,1,.6-.09l.05,0A.37.37,0,0,1,65,151c1.18,2.31,4.17,14.43,3.3,21-.38,3.69-2.07,6.43-4.65,7.51a5.34,5.34,0,0,1-5.34-.54c-3.54-2.73-1.28-9.83-.5-11.94,1.78-3.86,5.92-14.78,6.16-15.87A.49.49,0,0,1,64.09,150.75Zm1.35,26.07a9.24,9.24,0,0,0,1.84-5c.79-6-1.62-15.52-2.72-19.08-.36,1-1,2.64-1.91,5.12-1.23,3.21-2.89,7.39-3.87,9.51-1.46,4-2.18,8.89.19,10.72a4.3,4.3,0,0,0,4.29.4A5.7,5.7,0,0,0,65.44,176.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.57,56.61a.8.8,0,0,0-1.07,0,99.38,99.38,0,0,0-27.4,93,.77.77,0,0,0,.93.59.79.79,0,0,0,.59-.94,97.82,97.82,0,0,1,27-91.52.78.78,0,0,0,0-1.1S476.58,56.62,476.57,56.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.33,89.37c-8.73-3.94-4.79-18.88-4.39-18.88q1.37-2.05,2.85-4c-.63,2.12,1,7.3,5.48,12.92C477.54,85.11,477.51,93.42,469.33,89.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.67,76.85c-8.42-4.16,1.13-12.91,8.48-11.09,7.25,1.53,12.61,1.65,14.53.6-1.07,1.26-2.12,2.55-3.12,3.85C464.35,69.9,452.79,80.5,444.67,76.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,102.53c-9.26-2.43-7.95-17.68-7.57-17.73.65-1.48,1.35-3,2.08-4.4-.24,2.16,2.23,6.95,7.65,11.7C471.36,97,472.74,105.15,464,102.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.59,94.34c-9-2.7-1.09-12.82,6.43-12.24,7.39.32,12.67-.43,14.37-1.77q-1.25,2.1-2.39,4.27C455.76,84.32,446.22,96.56,437.59,94.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,116.34c-9.53-.86-10.8-16-10.45-16.16.4-1.56.83-3.11,1.31-4.65.13,2.15,3.38,6.43,9.52,10.21C467.29,109.68,470,117.45,461,116.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.55,112.68c-9.32-1.16-3.22-12.43,4.28-13.09,7.34-.92,12.41-2.52,13.86-4.11-.58,1.51-1.13,3-1.63,4.57C449.78,99.81,442.44,113.42,433.55,112.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.27,130.48c-9.54.74-13.33-14-13-14.2.13-1.6.3-3.21.51-4.8.49,2.09,4.41,5.77,11.09,8.46C465.4,122.83,469.39,130.06,460.27,130.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.64,131.47c-9.39.41-5.26-11.75,2-13.66,7.08-2.13,11.82-4.55,13-6.35-.32,1.58-.6,3.17-.84,4.76C446.49,116,441.52,130.69,432.64,131.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,144.66c-9.28,2.33-15.53-11.74-15.21-11.93-.15-1.61-.25-3.23-.31-4.84.84,2,5.32,5,12.36,6.52C465.73,136.17,470.9,142.7,462,144.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.91,150.3c-9.18,2-7.18-10.82-.31-13.93,6.63-3.31,10.88-6.51,11.72-8.48q-.07,2.43,0,4.86C445.94,132.59,443.53,148,434.91,150.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.43,142.13c-.21-.14-2.11,13.72.12,21.05,2,7.27,7.89,7.51,10.1,5.07s.67-7.43-1.5-11.26C453.7,153.38,447.26,142.29,447.43,142.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.78,141.74l-.06,0a.53.53,0,0,0-.61,0l0,0a.39.39,0,0,0-.16.37c-.79,2.47-1.78,14.92.14,21.22,1,3.57,3.08,6,5.8,6.65A5.35,5.35,0,0,0,458,168.6c3.05-3.27-.32-9.91-1.43-11.87-2.39-3.52-8.24-13.62-8.65-14.66A.59.59,0,0,0,447.78,141.74Zm2.89,25.95a9.18,9.18,0,0,1-2.62-4.64c-1.76-5.79-.92-15.57-.41-19.27.52,1,1.37,2.45,2.71,4.75,1.73,3,4,6.82,5.36,8.75,2.08,3.68,3.6,8.42,1.55,10.61A4.29,4.29,0,0,1,453.1,169,5.66,5.66,0,0,1,450.67,167.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.91,64.35a.79.79,0,0,0-.38-1,99.39,99.39,0,0,0-96.79,5.41.78.78,0,0,0,.84,1.32,97.79,97.79,0,0,1,95.26-5.32.78.78,0,0,0,1.05-.36S451.91,64.37,451.91,64.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.62,68.53c.78-9.55,16.18-10.85,16.31-10.47q2.4.6,4.77,1.32c-2.2.12-6.54,3.37-10.33,9.51C425.4,74.84,417.55,77.59,418.62,68.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.13,41.1c1.1-9.33,12.54-3.27,13.3,4.26,1,7.35,2.68,12.44,4.32,13.89-1.55-.59-3.12-1.14-4.69-1.65C435.28,57.31,421.42,50,422.13,41.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.44,67.93c-.83-9.53,14-13.43,14.15-13.09,1.62.12,3.23.28,4.85.49-2.12.49-5.8,4.44-8.46,11.13C412.11,73,404.9,77,404.44,67.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.28,40.3C402.8,30.92,415,35,417,42.25c2.18,7.07,4.66,11.79,6.49,12.94-1.6-.31-3.21-.59-4.82-.82C418.83,54.05,404.09,49.18,403.28,40.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.41,69.7C388,60.44,401.9,54.14,402.12,54.44c1.6-.15,3.21-.26,4.82-.34-2,.85-4.93,5.35-6.42,12.4C398.81,73.43,392.4,78.61,390.41,69.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.65,42.66c-2-9.17,10.62-7.21,13.77-.36,3.33,6.6,6.54,10.84,8.52,11.66-1.62,0-3.23,0-4.85,0C402.23,53.62,386.94,51.27,384.65,42.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.85,73.8c-3.9-8.73,8.77-17.28,9-17,1.55-.42,3.12-.79,4.69-1.14-1.81,1.17-3.95,6.1-4.25,13.3C385.78,76.06,380.31,82.25,376.85,73.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.65,48.11c-3.54-8.71,9.3-8.9,13.54-2.67,4.39,6,8.26,9.59,10.35,10.08-1.6.23-3.19.5-4.78.81C385.85,56,370.36,56.21,366.65,48.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.08,80.18c-5.32-8,5.84-18.57,6.13-18.34,1.46-.68,3-1.32,4.45-1.92-1.59,1.46-2.9,6.68-2,13.83C373.33,80.86,368.92,87.92,364.08,80.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.68,56.57c-5-8,7.77-10.4,13-5,5.34,5.13,9.78,8.07,11.92,8.19q-2.31.75-4.59,1.61C370.06,61,354.72,63.92,349.68,56.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.57,65.62c.06-.25-13.63,2.62-19.79,7.18-6.18,4.3-4.42,10-1.38,11.21s7.22-1.86,10.1-5.19C353.08,75.3,361.37,65.51,361.57,65.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.05,65.81l0-.06a.54.54,0,0,0-.22-.57l-.05,0a.39.39,0,0,0-.41,0c-2.58.09-14.64,3.34-19.93,7.26-3,2.12-4.63,4.93-4.32,7.71a5.3,5.3,0,0,0,3.05,4.4c4.11,1.78,9.22-3.63,10.69-5.33,2.52-3.43,10.07-12.34,10.91-13.07A.49.49,0,0,0,362.05,65.81ZM338.58,77.25a9.23,9.23,0,0,1,3.5-4c4.85-3.6,14.35-6.1,18-6.86-.73.82-1.84,2.11-3.55,4.15-2.21,2.63-5.07,6.1-6.45,8-2.76,3.19-6.72,6.21-9.47,5A4.29,4.29,0,0,1,338.18,80,5.69,5.69,0,0,1,338.58,77.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,48.06a1.5,1.5,0,0,1,1.86-.82A189.33,189.33,0,0,1,142.1,185.67a1.49,1.49,0,1,1-2.92.62A186.3,186.3,0,0,0,18.91,50.06a1.49,1.49,0,0,1-.92-1.9A1,1,0,0,1,18,48.06Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.91,98.77C68.81,85,50,62.32,49.28,62.65q-4-2.43-8.18-4.69c2.79,3.15,4.2,13.37.95,26.72C39.3,98,46.07,112.36,56.91,98.77Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.39,57.31C100.58,43.34,77,35.94,65.83,45c-11.29,8.5-20.44,13-24.61,12.75q4.31,2,8.5,4.14C49.83,61.17,78.32,70.15,89.39,57.31Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.72,117.19c14-11.64-.52-36.91-1.21-36.69q-3.49-3-7.15-5.93c2.16,3.54,1.74,13.8-3.77,26.37C59.57,113.59,63.73,128.76,76.72,117.19Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7,81.78c13.36-11.9-8.44-23-21-15.94-12.51,6.5-22.22,9.46-26.23,8.52Q72.36,77,76.08,79.8C76.27,79.12,102.6,92.57,115.7,81.78Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.08,138.58c15.75-9.15,5.72-36.41,5-36.29q-2.91-3.57-6-7c1.51,3.82-.66,13.83-8.21,25.29C76.79,132.19,78.34,147.81,93.08,138.58Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.44,110.19c15.15-9.51-4.44-24-17.94-19.15-13.4,4.34-23.44,5.65-27.21,4.07q3.33,3.21,6.49,6.58C99.06,101.05,122.7,118.62,137.44,110.19Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.67,162.44c17.06-6.4,11.69-35,11-35q-2.28-4-4.74-7.88c.84,4-3,13.51-12.33,23.54C90.65,153.36,89.59,169.06,105.67,162.44Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.16,141.89c16.53-6.85-.4-24.53-14.52-21.94-13.94,2-24.06,1.65-27.5-.52q2.73,3.7,5.29,7.55C117.8,126.37,138.21,147.7,154.16,141.89Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.13,188.29c17.9-3.45,17.35-32.77,16.65-32.85-1.05-2.9-2.17-5.76-3.37-8.6.16,4.11-5.17,12.86-16.07,21.2C100.82,176.66,97.16,192.08,114.13,188.29Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.39,176.22c17.45-4,3.69-24.46-10.68-24.3-14.09-.36-24-2.46-27.06-5.19q2.08,4.13,4,8.37C132.09,154.53,148.69,179.22,165.39,176.22Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,172.2c.25-.41,14.69,22,16.76,36.44,2.44,14.13-7.59,19.31-13.36,16.87s-7.13-12.27-6.47-20.64C135.45,196.66,137.64,172.33,137.21,172.2Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3,171.81l.06-.12a1,1,0,0,1,1.06-.46l.1,0a.73.73,0,0,1,.59.51c3.34,3.62,15.07,24.31,16.84,36.73,1.21,6.95-.49,12.86-4.66,16.17a10.16,10.16,0,0,1-10.06,1.75c-7.9-3.18-7.42-17.36-7.08-21.62,1.28-8,3.25-30.16,3.12-32.28A1,1,0,0,1,136.3,171.81Zm15.9,47.12c1-2.33,1.57-5.6.79-10.12-1.63-11.4-11-27.62-14.81-33.58-.12,2.08-.4,5.32-.86,10.37-.61,6.51-1.5,15-2.2,19.43-.63,8,.57,17.42,5.86,19.56a8.2,8.2,0,0,0,8.08-1.48A10.69,10.69,0,0,0,152.2,218.93Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.16,48.06a1.5,1.5,0,0,0-1.86-.82A189.31,189.31,0,0,0,370.09,185.67a1.49,1.49,0,1,0,2.92.62A186.3,186.3,0,0,1,493.28,50.06a1.49,1.49,0,0,0,.92-1.9A1,1,0,0,0,494.16,48.06Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.28,98.77c-11.9-13.82,6.94-36.45,7.63-36.12q4-2.43,8.18-4.69c-2.79,3.15-4.21,13.37-.95,26.72C472.89,98,466.12,112.36,455.28,98.77Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.79,57.31c-11.18-14,12.35-21.37,23.57-12.33,11.29,8.5,20.44,13,24.61,12.75q-4.31,2-8.51,4.14C462.36,61.17,433.87,70.15,422.79,57.31Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.47,117.19c-14-11.64.51-36.91,1.21-36.69q3.49-3,7.15-5.93c-2.16,3.54-1.74,13.8,3.77,26.37C452.62,113.59,448.45,128.76,435.47,117.19Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.49,81.78c-13.36-11.9,8.43-23,20.95-15.94,12.51,6.5,22.22,9.46,26.23,8.52q-3.85,2.63-7.56,5.44C435.92,79.12,409.59,92.57,396.49,81.78Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.1,138.58c-15.75-9.15-5.71-36.41-5-36.29q2.91-3.57,6-7c-1.51,3.82.65,13.83,8.21,25.29C435.4,132.19,433.84,147.81,419.1,138.58Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.75,110.19c-15.16-9.51,4.44-24,17.93-19.15,13.41,4.34,23.45,5.65,27.22,4.07q-3.33,3.21-6.49,6.58C413.13,101.05,389.49,118.62,374.75,110.19Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.52,162.44c-17.06-6.4-11.69-35-11-35q2.27-4,4.74-7.88c-.84,4,3,13.51,12.33,23.54C421.54,153.36,422.6,169.06,406.52,162.44Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,141.89c-16.53-6.85.4-24.53,14.51-21.94,13.95,2,24.07,1.65,27.51-.52q-2.73,3.7-5.29,7.55C394.39,126.37,374,147.7,358,141.89Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.06,188.29c-17.9-3.45-17.35-32.77-16.65-32.85,1-2.9,2.17-5.76,3.37-8.6C384.61,151,390,159.7,400.85,168,411.37,176.66,415,192.08,398.06,188.29Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.8,176.22c-17.46-4-3.69-24.46,10.68-24.3,14.09-.36,24-2.46,27.06-5.19q-2.09,4.13-4,8.37C380.1,154.53,363.5,179.22,346.8,176.22Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,172.2c-.25-.41-14.7,22-16.76,36.44-2.44,14.13,7.59,19.31,13.36,16.87s7.13-12.27,6.47-20.64C376.74,196.66,374.55,172.33,375,172.2Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.89,171.81l-.06-.12a1,1,0,0,0-1.07-.46l-.09,0a.73.73,0,0,0-.59.51c-3.34,3.62-15.07,24.31-16.84,36.73-1.21,6.95.49,12.86,4.66,16.17A10.16,10.16,0,0,0,372,226.42c7.9-3.18,7.42-17.36,7.08-21.62-1.28-8-3.25-30.16-3.12-32.28A1,1,0,0,0,375.89,171.81ZM360,218.93c-1-2.33-1.56-5.6-.78-10.12,1.63-11.4,11-27.62,14.81-33.58.12,2.08.4,5.32.86,10.37.6,6.51,1.5,15,2.2,19.43.63,8-.58,17.42-5.87,19.56a8.18,8.18,0,0,1-8.07-1.48A10.8,10.8,0,0,1,360,218.93Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--earth-globe--inject-39"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 319.57,
    r: 91.38,
    transform: "translate(-89.34 97.15) rotate(-18.72)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.82,411.48a92.2,92.2,0,1,1,20.1-2.22A92.32,92.32,0,0,1,249.82,411.48Zm.36-182.82a91.52,91.52,0,0,0-19.88,2.19,90.41,90.41,0,1,0,19.88-2.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.55,406.51h0a86.72,86.72,0,0,1-15-1.91.5.5,0,0,1-.39-.59.51.51,0,0,1,.6-.39,84.9,84.9,0,0,0,14.81,1.89.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,403.74l-.13,0c-2.55-.67-5.11-1.47-7.6-2.38a.5.5,0,0,1-.3-.64.49.49,0,0,1,.64-.3c2.47.9,5,1.69,7.52,2.35a.5.5,0,0,1,.35.61A.5.5,0,0,1,228,403.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.32,400.16a.43.43,0,0,1-.19,0,87.06,87.06,0,0,1-50.82-104.36.5.5,0,0,1,1,.28,86,86,0,0,0,50.23,103.15.51.51,0,0,1,.27.66A.5.5,0,0,1,217.32,400.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.44,286.14a.45.45,0,0,1-.2,0,.49.49,0,0,1-.26-.66,86.94,86.94,0,0,1,8-14.7.5.5,0,0,1,.69-.14.51.51,0,0,1,.14.7,85.75,85.75,0,0,0-7.94,14.54A.51.51,0,0,1,170.44,286.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.62 278.99 246.94 280.92 250.11 284.21 254.25 284.84 255.57 288.77 254.6 291.43 251.78 292.72 244.86 291.59 244.68 290.75 247.95 288.47 245.69 284.3 239.5 283.45 236.21 280.63 237.62 278.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.78,293.22h-.08l-6.92-1.13a.49.49,0,0,1-.4-.39l-.19-.84a.48.48,0,0,1,.2-.52l2.9-2-1.92-3.55-5.94-.81a.42.42,0,0,1-.25-.12l-3.3-2.82a.51.51,0,0,1-.17-.34.48.48,0,0,1,.12-.36l1.41-1.65a.49.49,0,0,1,.48-.16l9.32,1.93a.51.51,0,0,1,.26.14l3,3.17,4,.61a.49.49,0,0,1,.39.34l1.32,3.92a.47.47,0,0,1,0,.33l-1,2.66a.45.45,0,0,1-.26.28l-2.82,1.3A.52.52,0,0,1,251.78,293.22Zm-6.5-2.06,6.43,1,2.49-1.15.84-2.29-1.17-3.48L250,284.7a.53.53,0,0,1-.29-.14l-3.07-3.19-8.87-1.83-.9,1,2.81,2.4,6,.83a.51.51,0,0,1,.37.25l2.26,4.17a.51.51,0,0,1-.16.65l-3,2.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.69,365l-7.38-1.25-8.92-1.13L289.83,364l-6.42.09-6.45,3-3.76,1.06-2.33.51L267,372.21l-3.86,2.63-6.52-2.32.17-6.26-3.93-.68-4.23.94-1.06-1.77-.42-3.9-2-1.79-2.87,1.08-.37,2.31-3.55,1-4-3.11-2.4-4.8,1.86-6.63,6.24-.94,2,1.1,2.54-.56,2.75-2.61,2.94.24,5.27,5.71,1.44-.54-1.51-4.77-1.83-2.26-.47-4.12,7.08-5.13-.68-8.06,2.77-3.51,1.68-5.48,2-.89,4.16-4.26-.16-1.74-3.34,1-1-1.55-2.33.52L260,312.67l1.08-3.13,6.94-3.76,1.27-2.28,4,4,2.33,1.48,2.77-1.5L276.5,305l-5.15-2.19L265,298.23l-6.09-2.42-5.27.28-3.11-2L247,294l-.24.94.94,6.23,1.32,1.93-.4,7.2-5-2.45,0-3.1-4.92-1.13-2.42-1.91-.12-5.53,5.16-5.81-.71-5.17-2.28.73-1.91-1.58-1.34-3-1.53.11-.09,3.58-2.24.94-2.7-7.17-1.93-.69-3.24-.61-3,2.45,5.13,3.08,1.65,3.41-8.89-4-6.57-4.54-1.69-5.63-5.88-.47-3.62,3.69a32.67,32.67,0,0,1-2.8,2.4,36.51,36.51,0,0,1-4.89,2l-.05,3.79-4.82,1.29.94,2.23,8.11-.47,5,3.56,1.65,7.41-.87,7.08,2,6.89L201,323.32l2.16,15.74,3.88,8.47,4.25,6.16,3.27-.28-1.81-3.15-2.25-2.17-2.1-4.42,1.81-.85,4.66,7,3.62,6.3,1.22,5.51,5.11,4,8.37,3.7,11.67.51,4.09,2.43,3.3,2.82,4.32,1.48,4.94.24,4.61-1.25s.26,2.17.5,3.23-1.93,5.31-1.93,5.31l-1.39,4.75,2.73,4.29,5.08.87,8.07,5.31,3.24.62.71,3.17.7,1.4a91,91,0,0,0,39.76-30.77l-.23-1.56,3.41-11.64-3.18-1.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.87,405a.49.49,0,0,1-.45-.28l-.7-1.39a.56.56,0,0,1,0-.12l-.63-2.85-2.93-.55a.71.71,0,0,1-.18-.08l-8-5.26-5-.85a.49.49,0,0,1-.33-.23l-2.73-4.28a.49.49,0,0,1-.06-.41l1.39-4.75c1-2,2-4.52,1.92-5.07-.16-.73-.34-2-.43-2.69l-4.06,1.09a.26.26,0,0,1-.15,0l-4.94-.24-.14,0-4.33-1.49a.51.51,0,0,1-.16-.09l-3.29-2.82-3.92-2.31-11.54-.52a.39.39,0,0,1-.18,0L224.66,366l-.11-.06-5.1-4a.47.47,0,0,1-.18-.29l-1.21-5.43L214.48,350l-4.4-6.58-1,.45,1.84,3.88,2.19,2.1.09.12,1.81,3.15a.51.51,0,0,1,0,.48.52.52,0,0,1-.4.27l-3.27.28a.53.53,0,0,1-.46-.22l-4.25-6.16-3.93-8.54a1,1,0,0,1,0-.14l-2.16-15.74a.55.55,0,0,1,0-.22l3.58-11.55-1.94-6.74a.69.69,0,0,1,0-.2l.86-7-1.59-7.14-4.7-3.34-7.95.46a.5.5,0,0,1-.49-.3l-.94-2.24a.49.49,0,0,1,0-.41.47.47,0,0,1,.32-.26l4.45-1.2,0-3.41a.49.49,0,0,1,.35-.46,35.34,35.34,0,0,0,4.77-1.92,31.26,31.26,0,0,0,2.73-2.35l3.61-3.68a.54.54,0,0,1,.4-.15l5.88.48a.48.48,0,0,1,.44.35l1.64,5.45,6.42,4.45,7.56,3.41-1-2-5-3a.5.5,0,0,1-.24-.4.46.46,0,0,1,.18-.42l3-2.45a.49.49,0,0,1,.41-.1l3.24.61,2,.7a.5.5,0,0,1,.3.3l2.52,6.69,1.46-.62.08-3.25a.5.5,0,0,1,.47-.48l1.52-.12a.49.49,0,0,1,.5.29l1.29,2.93,1.61,1.33,2-.65a.52.52,0,0,1,.42.06.5.5,0,0,1,.23.35l.7,5.18a.49.49,0,0,1-.12.4l-5,5.66.1,5.09,2.15,1.7,4.81,1.1a.49.49,0,0,1,.39.48l0,2.8,4,2,.35-6.28-1.22-1.79a.5.5,0,0,1-.08-.2l-.94-6.24a.41.41,0,0,1,0-.19l.23-.94a.52.52,0,0,1,.5-.38l3.58.09a.57.57,0,0,1,.25.08l3,1.89,5.11-.27a.51.51,0,0,1,.21,0l6.09,2.43a.24.24,0,0,1,.11.06l6.31,4.55,5.1,2.17a.43.43,0,0,1,.2.15l1.88,2.47a.51.51,0,0,1,.09.41.49.49,0,0,1-.25.34l-2.78,1.5a.48.48,0,0,1-.5,0L273,307.92l-.09-.07-3.53-3.53-.94,1.71a.52.52,0,0,1-.2.19l-6.77,3.67-.63,1.81,2.33-1.12.11,0,2.33-.52a.51.51,0,0,1,.53.22l.8,1.24,3-.86a.48.48,0,0,1,.42.07.51.51,0,0,1,.22.36l.16,1.74a.53.53,0,0,1-.14.4l-4.16,4.26a.54.54,0,0,1-.16.1l-1.81.81-1.61,5.26a.8.8,0,0,1-.08.16l-2.66,3.35.67,7.87a.52.52,0,0,1-.21.45l-6.84,4.95.42,3.68,1.74,2.15a.56.56,0,0,1,.09.17l1.5,4.77a.5.5,0,0,1-.3.62l-1.43.54a.51.51,0,0,1-.55-.13l-5.13-5.57-2.52-.2-2.6,2.45a.41.41,0,0,1-.23.13l-2.54.56a.48.48,0,0,1-.35-.05l-1.87-1-5.75.86-1.72,6.14,2.26,4.52,3.73,2.89,3-.86.33-2a.51.51,0,0,1,.32-.39l2.87-1.08a.5.5,0,0,1,.51.1l1.95,1.79a.47.47,0,0,1,.16.31l.41,3.8.82,1.36,3.88-.86a.45.45,0,0,1,.2,0l3.93.69a.49.49,0,0,1,.41.5l-.16,5.9,5.94,2.12,3.65-2.49,3.82-3.49a.57.57,0,0,1,.23-.12l2.33-.51,3.74-1.05,6.37-3a.46.46,0,0,1,.2-.05l6.37-.09,6.51-1.45h.18l8.91,1.14,7.24,1.22,10.79-5.68a.52.52,0,0,1,.42,0L327,360a.51.51,0,0,1,.29.6l-3.38,11.54.21,1.45a.49.49,0,0,1-.09.37,91.53,91.53,0,0,1-40,30.93A.39.39,0,0,1,283.87,405Zm-.23-2.07.47.93a90.55,90.55,0,0,0,39-30.26l-.2-1.35a.55.55,0,0,1,0-.22l3.28-11.21-2.54-1-10.73,5.65a.51.51,0,0,1-.32.05l-7.39-1.25-8.8-1.11-6.48,1.44h-.1l-6.32.09-6.35,2.94-3.84,1.09-2.22.49-3.79,3.44-3.91,2.68a.51.51,0,0,1-.45.06L256.45,373a.52.52,0,0,1-.34-.49l.16-5.82-3.41-.6-4.13.92a.49.49,0,0,1-.54-.23L247.13,365a.48.48,0,0,1-.07-.21l-.4-3.71-1.59-1.46-2.31.88-.33,2a.51.51,0,0,1-.36.4l-3.55,1a.5.5,0,0,1-.44-.09l-4-3.1a.49.49,0,0,1-.14-.18l-2.4-4.79a.51.51,0,0,1,0-.36l1.86-6.64a.51.51,0,0,1,.41-.36l6.23-.94a.59.59,0,0,1,.32.06l1.86,1,2.22-.5,2.65-2.51a.49.49,0,0,1,.38-.14l2.94.24a.46.46,0,0,1,.33.16l5,5.47.68-.26-1.34-4.23-1.77-2.19a.47.47,0,0,1-.11-.26l-.47-4.11a.5.5,0,0,1,.2-.46l6.86-5-.66-7.78a.52.52,0,0,1,.11-.36l2.71-3.43,1.65-5.39a.52.52,0,0,1,.27-.31l1.94-.85,3.93-4-.08-.91-2.76.79a.5.5,0,0,1-.56-.21l-.82-1.26-1.94.43-3.36,1.62a.5.5,0,0,1-.55-.07.52.52,0,0,1-.14-.54l1.09-3.13a.47.47,0,0,1,.23-.27l6.81-3.7,1.2-2.15a.53.53,0,0,1,.37-.26.53.53,0,0,1,.42.15l4,4,2,1.29,2-1.08-1.45-1.9-5-2.14-.09-.06-6.3-4.55-5.94-2.36-5.16.28a.44.44,0,0,1-.29-.08l-3-1.9-3-.08-.11.45.91,6,1.25,1.84a.56.56,0,0,1,.09.31l-.4,7.2a.51.51,0,0,1-.72.42l-5-2.45a.49.49,0,0,1-.28-.44l0-2.71-4.53-1.05a.4.4,0,0,1-.2-.09l-2.42-1.91a.47.47,0,0,1-.19-.38l-.12-5.53a.55.55,0,0,1,.13-.34l5-5.64-.59-4.35-1.72.54a.47.47,0,0,1-.47-.09l-1.91-1.57a.5.5,0,0,1-.13-.19l-1.2-2.71-.73.06-.08,3.12a.52.52,0,0,1-.31.45l-2.23.94a.48.48,0,0,1-.39,0,.47.47,0,0,1-.27-.28l-2.63-7-1.71-.61-2.94-.54-2.28,1.85,4.52,2.71a.48.48,0,0,1,.19.21l1.65,3.41a.52.52,0,0,1-.09.57.53.53,0,0,1-.57.11l-8.89-4-6.64-4.58a.52.52,0,0,1-.19-.27l-1.6-5.3-5.31-.42-3.46,3.53a33.27,33.27,0,0,1-2.87,2.46,31.23,31.23,0,0,1-4.68,1.92l0,3.43a.52.52,0,0,1-.37.48l-4.27,1.14.58,1.38,7.76-.44a.45.45,0,0,1,.32.09l5,3.55a.52.52,0,0,1,.2.3l1.65,7.41a.48.48,0,0,1,0,.17l-.86,7,1.95,6.79a.48.48,0,0,1,0,.29l-3.59,11.58,2.13,15.56,3.85,8.4,4.05,5.85,2.2-.19-1.38-2.41-2.21-2.12a.76.76,0,0,1-.11-.14L208,343.88a.5.5,0,0,1,0-.38.48.48,0,0,1,.26-.28l1.81-.85a.51.51,0,0,1,.63.17l4.66,7,3.64,6.33a.78.78,0,0,1,.05.14l1.18,5.33,4.92,3.83,8.23,3.63,11.57.52a.46.46,0,0,1,.23.06l4.1,2.43,3.29,2.81,4.17,1.43,4.79.23L266,375a.5.5,0,0,1,.41.07.51.51,0,0,1,.22.35s.26,2.16.49,3.18-1.45,4.61-2,5.65l-1.29,4.45,2.49,3.9,4.86.83a.41.41,0,0,1,.19.08l8,5.26,3.14.59a.5.5,0,0,1,.4.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.14,276.43l-3.22-3.5-4-4-2.26-6.17,4-.21-.26-2.16-2.8.4,2.09-1.58,2.21-2-.47-2.12-3.29-2.82-1.55-4.44a91.43,91.43,0,0,0-110.33-2.12l5.65,2.38-2.12,4.47-3.83,1.74.84,5.81-1.55,1-1.6,2.8,1.06,3.76,3.69-.38-.68,3.93,3.6-.8,4.4-9.19-.12-3.53,5.84-1.74.91-2.87,6-2-.16-3.74,4.4-1.2a22.94,22.94,0,0,1,3.43-2.54,26.62,26.62,0,0,1,3.84.26l3.74,1.84,4.44-1,3.3-3.18,5-.65a5.35,5.35,0,0,0,2.52.32c1.05-.23,3.9-2.42,3.9-2.42l7,2.45,3,1.34.71,3.18,3.27-.28.63-2.15,3,.66.16,1.74-6,3.11,4.64,3.86,8.56,2.54,4.12,3.53,4.75-.61.59-2.36,1.6-.79-6.45-3-3.48.33,2.56-1.46-3.34-3,3.56-1,5.22,1.5,2.19,4.85,2.94,2.24,3.26,5.71,5.41,2.36,1.56,7,5.57,2.1.31,2.37,0,2.9,2.12,3.52.85,1.82,3.74-.17.89-4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,283.64a.51.51,0,0,1-.45-.29l-.84-1.81-2.1-3.49a.59.59,0,0,1-.07-.26l0-2.89-.27-2-5.29-2a.47.47,0,0,1-.31-.36l-1.5-6.74L295,261.55a.52.52,0,0,1-.23-.21l-3.22-5.63-2.86-2.17a.55.55,0,0,1-.15-.19l-2.09-4.64-4.86-1.4L279,248l2.67,2.43a.5.5,0,0,1,.16.43.51.51,0,0,1-.25.38l-.54.31,1.16-.12a.58.58,0,0,1,.26,0l6.45,3a.53.53,0,0,1,.29.45.5.5,0,0,1-.28.45l-1.39.7-.54,2.13a.48.48,0,0,1-.42.37l-4.75.61a.5.5,0,0,1-.39-.11l-4-3.46L269,253.15a.52.52,0,0,1-.18-.1l-4.63-3.86a.49.49,0,0,1-.18-.44.53.53,0,0,1,.26-.39l5.68-2.94-.1-1-2.22-.49-.5,1.7a.5.5,0,0,1-.44.35l-3.27.29a.5.5,0,0,1-.53-.39l-.65-2.94-2.74-1.23-6.69-2.35a16.39,16.39,0,0,1-3.89,2.35,5.51,5.51,0,0,1-2.68-.3l-4.68.62-3.17,3.06a.56.56,0,0,1-.24.13l-4.45,1a.4.4,0,0,1-.32,0l-3.67-1.79a21.88,21.88,0,0,0-3.58-.26,22.17,22.17,0,0,0-3.22,2.43.44.44,0,0,1-.19.1l-4,1.1.14,3.34a.52.52,0,0,1-.34.5l-5.76,1.91-.84,2.63a.5.5,0,0,1-.33.33L206.07,258l.11,3.14a.59.59,0,0,1-.05.23l-4.4,9.2a.49.49,0,0,1-.34.27l-3.6.8a.49.49,0,0,1-.46-.13.48.48,0,0,1-.14-.44l.57-3.28-3,.31a.5.5,0,0,1-.53-.36L193.13,264a.46.46,0,0,1,.05-.38l1.6-2.8a.44.44,0,0,1,.16-.17l1.28-.84-.8-5.49a.51.51,0,0,1,.29-.53l3.67-1.66,1.81-3.83L196,246.13a.49.49,0,0,1-.1-.86,91.93,91.93,0,0,1,110.92,2.13.46.46,0,0,1,.17.22l1.51,4.31,3.19,2.74a.47.47,0,0,1,.16.27l.47,2.12a.49.49,0,0,1-.15.47L310,259.58l-.58.44.88-.13a.55.55,0,0,1,.37.1.47.47,0,0,1,.19.34l.26,2.16a.5.5,0,0,1-.11.39.53.53,0,0,1-.36.17l-3.27.18,2,5.42,3.92,3.92,3.24,3.52a.52.52,0,0,1,.12.45l-.54,2.56-.9,4a.5.5,0,0,1-.46.39l-3.74.17Zm-2.46-6,2.05,3.41.73,1.55,3-.13,1.3-5.91-3.05-3.32-4-4a.57.57,0,0,1-.12-.18l-2.26-6.16a.51.51,0,0,1,.06-.45.5.5,0,0,1,.39-.23l3.42-.18-.14-1.12-2.29.32a.5.5,0,0,1-.53-.3.49.49,0,0,1,.16-.59l2.09-1.58,2-1.82-.37-1.67-3.17-2.71a.64.64,0,0,1-.14-.22l-1.51-4.3a90.91,90.91,0,0,0-108.88-2.53l4.82,2a.48.48,0,0,1,.26.67l-2.12,4.47a.47.47,0,0,1-.24.24l-3.49,1.59.79,5.43a.51.51,0,0,1-.22.5l-1.45.94-1.44,2.51.89,3.16,3.27-.33a.5.5,0,0,1,.42.15.53.53,0,0,1,.13.43l-.56,3.19,2.63-.58,4.24-8.87-.11-3.4a.5.5,0,0,1,.36-.5l5.58-1.66.84-2.62a.48.48,0,0,1,.32-.33l5.64-1.87-.15-3.37a.49.49,0,0,1,.37-.5l4.29-1.17a17.63,17.63,0,0,1,3.56-2.58,24.68,24.68,0,0,1,4,.25l.16,0,3.58,1.76,4.14-.92,3.19-3.08a.49.49,0,0,1,.28-.13l5-.66a.52.52,0,0,1,.25,0,4.86,4.86,0,0,0,2.23.31,17.76,17.76,0,0,0,3.71-2.33.5.5,0,0,1,.47-.08l7,2.45,3,1.36a.48.48,0,0,1,.28.34l.61,2.75,2.49-.21.54-1.82a.5.5,0,0,1,.59-.34l3,.66a.49.49,0,0,1,.39.44l.17,1.74a.51.51,0,0,1-.27.49l-5.31,2.76,4,3.31,8.46,2.51a.5.5,0,0,1,.19.1l3.94,3.38,4.2-.54.5-2a.49.49,0,0,1,.26-.32l.68-.34-5.39-2.52-3.34.32a.51.51,0,0,1-.53-.35.5.5,0,0,1,.23-.58l2-1.12-2.83-2.57a.5.5,0,0,1,.2-.85l3.55-1a.45.45,0,0,1,.28,0l5.22,1.5a.51.51,0,0,1,.31.28l2.14,4.73,2.84,2.16a.47.47,0,0,1,.13.15l3.19,5.57,5.25,2.29a.47.47,0,0,1,.29.35l1.49,6.72,5.33,2a.51.51,0,0,1,.32.4l.3,2.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.16,254.49l.27,1.22-.31,3.62,1.29,2.82,2.52.33.89,4-2.77-.5,1.9,11.58-1.5,5.22,3,5.55,3.31,1.93,2.54,11.43L330,310l4.47,6.12,5.15.19.75-4.61.57-.7a91.67,91.67,0,0,0-26.82-56.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.66,316.81h0l-5.15-.19a.51.51,0,0,1-.39-.21l-4.47-6.11L324.88,302a.42.42,0,0,1-.06-.14l-2.49-11.22-3.12-1.82a.5.5,0,0,1-.19-.19L316,283a.48.48,0,0,1-.05-.37l1.48-5.12-1.89-11.46a.49.49,0,0,1,.15-.43.48.48,0,0,1,.44-.14l2,.36-.65-2.95-2.17-.28a.49.49,0,0,1-.39-.29l-1.29-2.82a.45.45,0,0,1-.05-.25l.3-3.55-.25-1.14a.5.5,0,0,1,.24-.55.52.52,0,0,1,.6.09,92.12,92.12,0,0,1,27,56.82.52.52,0,0,1-.11.36l-.49.59-.73,4.48A.5.5,0,0,1,339.66,316.81Zm-4.89-1.18,4.47.16.68-4.17a.44.44,0,0,1,.11-.24l.43-.53a91.58,91.58,0,0,0-1.74-11A90.56,90.56,0,0,0,314.91,256l-.28,3.29,1.12,2.45,2.25.3a.5.5,0,0,1,.42.39l.89,4a.49.49,0,0,1-.12.45.51.51,0,0,1-.45.15l-2.08-.37,1.79,10.87a.53.53,0,0,1,0,.22l-1.45,5,2.85,5.25,3.19,1.86a.49.49,0,0,1,.24.32l2.52,11.36,4.69,8.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.96 264.03 249.62 260.99 243.53 262.57 242.94 266.92 239.79 264.73 235.36 266.82 236.49 273.9 240.91 275.81 242.77 271.18 246.66 273.65 254.49 277.9 257.12 283.76 264.18 289.53 272.74 286.07 271.82 282.94 269.12 279.77 266.81 271.39 268.13 267.32 264.96 264.03",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.18,290a.52.52,0,0,1-.32-.11l-7.06-5.77a.62.62,0,0,1-.14-.18l-2.56-5.71-7.68-4.17L243,271.92,241.38,276a.51.51,0,0,1-.27.27.53.53,0,0,1-.39,0l-4.43-1.91A.52.52,0,0,1,236,274l-1.13-7.08a.51.51,0,0,1,.28-.53l4.42-2.09a.5.5,0,0,1,.5,0l2.48,1.72.48-3.54a.52.52,0,0,1,.37-.42l6.1-1.57a.54.54,0,0,1,.22,0l15.33,3a.54.54,0,0,1,.27.14l3.17,3.29a.53.53,0,0,1,.12.51l-1.27,3.92,2.23,8.13,2.63,3.09a.4.4,0,0,1,.1.18l.92,3.13a.49.49,0,0,1-.29.6L264.36,290A.39.39,0,0,1,264.18,290Zm-6.65-6.58,6.73,5.5,7.87-3.17-.76-2.6-2.63-3.09a.5.5,0,0,1-.1-.19l-2.31-8.38a.53.53,0,0,1,0-.28l1.22-3.79-2.85-3-15.08-3L244,263l-.55,4a.49.49,0,0,1-.29.39.51.51,0,0,1-.49-.05l-2.91-2-3.82,1.81,1,6.43,3.7,1.6,1.67-4.16a.5.5,0,0,1,.31-.29.48.48,0,0,1,.42.05l3.88,2.47,7.81,4.25a.47.47,0,0,1,.21.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.42 266.15 274.06 266 271.82 268.95 274.67 274.76 277.42 274.14 277.42 266.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.67,275.26a.51.51,0,0,1-.45-.28l-2.84-5.81a.49.49,0,0,1,.05-.53l2.23-2.94a.54.54,0,0,1,.42-.19l3.36.14a.5.5,0,0,1,.48.5v8a.49.49,0,0,1-.39.49l-2.75.61ZM272.41,269l2.54,5.18,2-.44v-7.11l-2.62-.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.01 265.8 289.96 263.58 287.92 261.37 286.36 262.38 288.79 266.29 291.28 271.51 294.74 272.08 295.18 271.09 292.57 268.34 298.55 269.23 298.01 265.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.74,272.58h-.09L291.2,272a.51.51,0,0,1-.37-.28l-2.5-5.22-2.39-3.86a.49.49,0,0,1,.15-.68l1.55-1a.5.5,0,0,1,.64.08l2,2.11,7.91,2.17a.52.52,0,0,1,.36.41l.54,3.43a.49.49,0,0,1-.14.43.49.49,0,0,1-.43.15l-4.54-.68,1.62,1.7a.5.5,0,0,1,.09.55l-.45,1A.5.5,0,0,1,294.74,272.58Zm-3.12-1.52,2.82.46.15-.33-2.38-2.51a.49.49,0,0,1-.08-.57.5.5,0,0,1,.52-.27l5.3.8-.39-2.45-7.73-2.12a.61.61,0,0,1-.24-.15l-1.75-1.9-.79.52,2.16,3.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.16 355.95 252.5 356.99 259.27 357.48 262.47 359.88 266.59 359.42 267.56 356.76 262.5 356.99 253.16 355.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.47,360.38a.49.49,0,0,1-.3-.1L259.09,358l-6.63-.48a.5.5,0,0,1-.41-.28.48.48,0,0,1,0-.49l.66-1a.49.49,0,0,1,.47-.23l9.34,1,5-.23a.49.49,0,0,1,.43.2.52.52,0,0,1,.07.47l-1,2.66a.49.49,0,0,1-.41.32l-4.12.47Zm-2.77-3.2,2.91,2.18,3.62-.41.6-1.66-4.31.2Zm-6.33-.63,1.88.14-1.84-.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.89 355.79 268.73 358.05 269.74 359.6 275.25 358.38 275.93 356.45 274.07 357.09 272.89 355.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.74,360.1a.52.52,0,0,1-.42-.22l-1-1.56a.51.51,0,0,1,.18-.71l4.17-2.26a.49.49,0,0,1,.6.11l1,1.05,1.55-.53a.48.48,0,0,1,.51.12.5.5,0,0,1,.12.52l-.68,1.93a.52.52,0,0,1-.36.32l-5.51,1.22Zm-.29-1.87.52.81,4.9-1.09.24-.69-.88.3a.5.5,0,0,1-.53-.14l-.91-1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--water-drops-2--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.38,39.64l-3.49-.54C484.15,39.26,485.32,39.43,486.38,39.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466,342.19a10,10,0,0,1-7.14-3,10.5,10.5,0,0,1-3-7.44c.05-3.57,2.76-7.27,5.37-10.85l1.09-1.5a45.74,45.74,0,0,0,3.2-5.08l.14-.27.64,0,.18.29a52,52,0,0,0,3.29,5.2c.43.6.87,1.19,1.31,1.79,2.43,3.29,4.94,6.69,5.06,10.43h0A10.18,10.18,0,0,1,466,342.19Zm0-26.68a50.25,50.25,0,0,1-2.88,4.47c-.35.5-.72,1-1.09,1.51-2.52,3.45-5.13,7-5.18,10.27a9.52,9.52,0,0,0,2.71,6.73,9.06,9.06,0,0,0,13-.09,9.18,9.18,0,0,0,2.58-6.63h0c-.11-3.43-2.53-6.7-4.86-9.86-.45-.61-.89-1.21-1.32-1.81A51.42,51.42,0,0,1,466,315.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466,315s-.23.45-.68,1.22a13.34,13.34,0,0,0,.9,5.23c1.74,5.5,2.3,11.8-.62,14.05-2.5,1.92-6.1,2.48-8.43-.13a9.59,9.59,0,0,0,18.42-3.72c0-2.95-3.7-7.8-6.34-11.51A49.43,49.43,0,0,1,466,315Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.42,328.63c0,1.75-1.09,3.18-2.44,3.18s-2.45-1.43-2.45-3.18,1.1-3.18,2.45-3.18S471.42,326.87,471.42,328.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.49,334.7a1.27,1.27,0,1,1-1.23-1.59A1.44,1.44,0,0,1,468.49,334.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.88,329.9c-.68,2.08-1.88,3.54-2.68,3.28S457.31,331,458,329s1.88-3.54,2.68-3.28S461.56,327.83,460.88,329.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.53,253.62A20.71,20.71,0,0,1,64.7,247.4a21.75,21.75,0,0,1-6.22-15.46c.1-7.42,5.82-15.24,11.34-22.8.78-1.07,1.56-2.14,2.31-3.19A101.57,101.57,0,0,0,79,195.05l.14-.26.38,0h0a.61.61,0,0,1,.52.31,109.19,109.19,0,0,0,7,11.15c.9,1.28,1.84,2.55,2.79,3.83,5.12,6.93,10.42,14.11,10.68,21.9h0a21.1,21.1,0,0,1-5.95,15.27A20.85,20.85,0,0,1,79.53,253.62Zm0-57.44A109,109,0,0,1,73,206.53l-2.32,3.2c-5.43,7.44-11,15.12-11.15,22.22a20.75,20.75,0,0,0,5.94,14.75,19.85,19.85,0,0,0,28.48-.2A20.1,20.1,0,0,0,99.57,232h0c-.25-7.48-5.45-14.53-10.49-21.34-.94-1.28-1.89-2.56-2.8-3.84A115.48,115.48,0,0,1,79.53,196.18Zm.36-.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.51,196.24s-.5,1-1.46,2.59c-.22,1.79,0,5.11,1.92,11.15,3.71,11.74,4.91,25.16-1.32,30-5.32,4.09-13,5.3-18-.27a20.43,20.43,0,0,0,39.25-7.92c0-6.31-7.89-16.65-13.51-24.55A103.78,103.78,0,0,1,79.51,196.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,225.29c0,3.74-2.34,6.78-5.22,6.78s-5.21-3-5.21-6.78,2.33-6.78,5.21-6.78S91,221.54,91,225.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.78,238.24c0,1.87-1.17,3.39-2.61,3.39s-2.61-1.52-2.61-3.39,1.17-3.39,2.61-3.39S84.78,236.37,84.78,238.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.56,228c-1.45,4.42-4,7.55-5.71,7s-1.9-4.6-.45-9,4-7.54,5.7-7S70,223.59,68.56,228Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.19,316.24a13,13,0,0,1-9.33-3.92,13.67,13.67,0,0,1-3.92-9.73c.07-4.66,3.63-9.54,7.07-14.26q.73-1,1.44-2a64.15,64.15,0,0,0,4.25-6.74l.14-.26.35,0a.53.53,0,0,1,.49.3,70.76,70.76,0,0,0,4.36,6.89c.56.79,1.15,1.58,1.73,2.37,3.2,4.33,6.51,8.81,6.67,13.7a13.28,13.28,0,0,1-3.75,9.61A13.12,13.12,0,0,1,103.19,316.24Zm0-35.45a68,68,0,0,1-3.93,6.15l-1.44,2c-3.35,4.59-6.82,9.34-6.88,13.68a12.68,12.68,0,0,0,3.63,9,12.12,12.12,0,0,0,17.4-.12,12.32,12.32,0,0,0,3.47-8.89c-.15-4.58-3.37-8.93-6.47-13.14-.59-.79-1.18-1.59-1.74-2.38A72.92,72.92,0,0,1,103.19,280.79Zm.39-.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.18,280.44s-.31.6-.9,1.61c-.15,1.11,0,3.16,1.18,6.92,2.31,7.28,3.05,15.61-.81,18.58-3.31,2.54-8.08,3.29-11.16-.17a12.68,12.68,0,0,0,24.36-4.91c0-3.91-4.89-10.33-8.39-15.23A66.43,66.43,0,0,1,103.18,280.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.33,298.46c0,2.33-1.45,4.21-3.23,4.21s-3.24-1.88-3.24-4.21,1.45-4.2,3.24-4.2S110.33,296.14,110.33,298.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.83,
    cy: 306.5,
    rx: 1.62,
    ry: 2.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.38,300.15c-.9,2.74-2.48,4.69-3.54,4.34s-1.18-2.85-.28-5.59,2.49-4.69,3.54-4.34S97.28,297.41,96.38,300.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.8,450.13a13,13,0,0,1-9.34-3.92,13.66,13.66,0,0,1-3.91-9.73c.06-4.66,3.62-9.54,7.07-14.25.48-.67,1-1.33,1.43-2a62,62,0,0,0,4.25-6.74l.14-.27.35,0a.52.52,0,0,1,.5.29,67.79,67.79,0,0,0,4.36,6.9c.56.79,1.15,1.58,1.73,2.37,3.2,4.33,6.5,8.81,6.67,13.7a13.28,13.28,0,0,1-3.75,9.61A13.12,13.12,0,0,1,320.8,450.13Zm0-35.45a67.14,67.14,0,0,1-3.93,6.15l-1.45,2c-3.35,4.59-6.81,9.33-6.87,13.68a12.66,12.66,0,0,0,3.62,9,12.14,12.14,0,0,0,17.41-.12,12.32,12.32,0,0,0,3.47-8.89c-.16-4.58-3.37-8.93-6.47-13.13-.59-.8-1.18-1.59-1.74-2.39A71.37,71.37,0,0,1,320.8,414.68Zm.39-.71h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.78,414.33s-.3.6-.9,1.61c-.14,1.11,0,3.17,1.19,6.92,2.3,7.28,3.05,15.61-.82,18.58-3.3,2.54-8.07,3.29-11.15-.16a12.68,12.68,0,0,0,24.36-4.92c0-3.91-4.9-10.33-8.39-15.23A64.39,64.39,0,0,1,320.78,414.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.94,432.36c0,2.32-1.45,4.2-3.24,4.2s-3.23-1.88-3.23-4.2,1.45-4.21,3.23-4.21S327.94,430,327.94,432.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.06,440.39a1.67,1.67,0,1,1-1.62-2.1A1.91,1.91,0,0,1,324.06,440.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,434c-.9,2.74-2.49,4.69-3.54,4.34s-1.18-2.85-.28-5.59,2.48-4.69,3.54-4.34S314.89,431.3,314,434Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.9,225.49a13.07,13.07,0,0,1-9.34-3.92,13.72,13.72,0,0,1-3.91-9.73c.06-4.67,3.62-9.54,7.07-14.26.49-.67,1-1.33,1.43-2a62.31,62.31,0,0,0,4.25-6.74l.14-.26.35,0a.61.61,0,0,1,.5.29,67.79,67.79,0,0,0,4.36,6.91c.56.79,1.15,1.58,1.73,2.37,3.2,4.33,6.5,8.8,6.67,13.7h0a13.29,13.29,0,0,1-3.75,9.61A13.12,13.12,0,0,1,419.9,225.49Zm0-35.45a68.82,68.82,0,0,1-3.93,6.14c-.47.66-1,1.32-1.44,2-3.36,4.59-6.82,9.34-6.88,13.68a12.61,12.61,0,0,0,3.63,9,12.1,12.1,0,0,0,17.4-.12,12.29,12.29,0,0,0,3.47-8.88h0c-.15-4.58-3.37-8.93-6.47-13.14-.59-.79-1.18-1.59-1.74-2.38A72.92,72.92,0,0,1,419.9,190Zm.39-.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.88,189.68s-.3.6-.9,1.61c-.14,1.12,0,3.17,1.19,6.92,2.31,7.29,3.05,15.61-.82,18.59-3.3,2.54-8.07,3.29-11.15-.17a12.68,12.68,0,0,0,24.36-4.92c0-3.91-4.9-10.32-8.39-15.23A64.39,64.39,0,0,1,419.88,189.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,207.71c0,2.33-1.45,4.21-3.24,4.21s-3.23-1.88-3.23-4.21,1.45-4.21,3.23-4.21S427,205.39,427,207.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.16,215.75a1.67,1.67,0,1,1-1.62-2.1A1.91,1.91,0,0,1,423.16,215.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.09,209.4c-.9,2.74-2.49,4.68-3.54,4.34s-1.18-2.85-.28-5.6,2.48-4.68,3.54-4.33S414,206.65,413.09,209.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.64,68.14a13,13,0,0,1-9.33-3.92,13.67,13.67,0,0,1-3.92-9.73c.07-4.66,3.63-9.54,7.07-14.25l1.44-2a63.78,63.78,0,0,0,4.25-6.74l.14-.27.35,0h0a.54.54,0,0,1,.49.29,69,69,0,0,0,4.36,6.9l1.73,2.37c3.2,4.33,6.51,8.81,6.67,13.7h0a13.31,13.31,0,0,1-3.74,9.62A13.13,13.13,0,0,1,289.64,68.14Zm0-35.45a67.14,67.14,0,0,1-3.93,6.15l-1.44,2c-3.35,4.59-6.82,9.33-6.88,13.68a12.69,12.69,0,0,0,3.63,9,12,12,0,0,0,8.62,3.62,12.29,12.29,0,0,0,12.25-12.62h0c-.15-4.59-3.36-8.94-6.47-13.14-.59-.8-1.17-1.59-1.74-2.39A72.92,72.92,0,0,1,289.64,32.69ZM290,32h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.63,32.34s-.31.6-.9,1.61c-.14,1.11,0,3.17,1.18,6.92,2.31,7.28,3,15.61-.81,18.58-3.31,2.54-8.08,3.29-11.16-.16a12.68,12.68,0,0,0,24.36-4.92c0-3.91-4.89-10.33-8.38-15.23A64.39,64.39,0,0,1,289.63,32.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.78,50.37c0,2.32-1.44,4.2-3.23,4.2s-3.24-1.88-3.24-4.2,1.45-4.21,3.24-4.21S296.78,48,296.78,50.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.9,58.4a1.67,1.67,0,1,1-1.62-2.1A1.91,1.91,0,0,1,292.9,58.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.83,52.05c-.9,2.75-2.48,4.69-3.54,4.34s-1.18-2.85-.28-5.59,2.49-4.69,3.54-4.34S283.73,49.31,282.83,52.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.16,453.4a13,13,0,0,1-9.33-3.92,13.67,13.67,0,0,1-3.92-9.73c.06-4.66,3.63-9.54,7.07-14.25l1.44-2a66.51,66.51,0,0,0,4.25-6.74l.14-.27.35,0a.49.49,0,0,1,.49.29,67.79,67.79,0,0,0,4.36,6.9c.56.79,1.15,1.58,1.73,2.37,3.2,4.33,6.51,8.81,6.67,13.7a13.28,13.28,0,0,1-3.75,9.61A13.12,13.12,0,0,1,144.16,453.4Zm0-35.45a68,68,0,0,1-3.93,6.15l-1.44,2c-3.35,4.59-6.82,9.33-6.88,13.67a12.68,12.68,0,0,0,3.63,9,12.12,12.12,0,0,0,17.4-.12,12.32,12.32,0,0,0,3.47-8.89c-.15-4.58-3.36-8.93-6.47-13.13-.59-.8-1.18-1.59-1.74-2.39A72.92,72.92,0,0,1,144.16,418Zm.39-.71h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.15,417.6s-.31.6-.9,1.61c-.15,1.11,0,3.17,1.18,6.92,2.31,7.28,3,15.61-.81,18.58-3.31,2.54-8.08,3.29-11.16-.16a12.68,12.68,0,0,0,24.36-4.92c0-3.91-4.89-10.33-8.39-15.23A65.16,65.16,0,0,1,144.15,417.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3,435.63c0,2.32-1.45,4.2-3.23,4.2s-3.24-1.88-3.24-4.2,1.45-4.21,3.24-4.21S151.3,433.3,151.3,435.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.42,443.66a1.67,1.67,0,1,1-1.62-2.1A1.91,1.91,0,0,1,147.42,443.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.35,437.31c-.9,2.74-2.48,4.69-3.54,4.34s-1.18-2.85-.28-5.59,2.49-4.69,3.54-4.34S138.25,434.57,137.35,437.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.73,357.57a13,13,0,0,1-9.33-3.92,13.67,13.67,0,0,1-3.92-9.73c.06-4.66,3.63-9.54,7.07-14.25l1.44-2A67.75,67.75,0,0,0,36.24,321l.14-.27.34,0a.51.51,0,0,1,.5.29,68.21,68.21,0,0,0,4.36,6.9c.56.79,1.15,1.58,1.73,2.37,3.2,4.33,6.51,8.81,6.67,13.7h0a13.32,13.32,0,0,1-3.75,9.62A13.11,13.11,0,0,1,36.73,357.57Zm0-35.45a68,68,0,0,1-3.93,6.15l-1.44,2c-3.35,4.59-6.82,9.33-6.88,13.68a12.65,12.65,0,0,0,3.63,9,12,12,0,0,0,8.62,3.62,12.12,12.12,0,0,0,8.78-3.74A12.29,12.29,0,0,0,49,344h0c-.15-4.59-3.37-8.94-6.47-13.14-.59-.8-1.18-1.59-1.74-2.39A72.92,72.92,0,0,1,36.73,322.12Zm.39-.71h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.72,321.77s-.31.6-.9,1.61c-.15,1.11,0,3.17,1.18,6.92,2.31,7.28,3,15.61-.82,18.58-3.3,2.54-8.07,3.29-11.15-.16a12.68,12.68,0,0,0,24.36-4.92c0-3.91-4.89-10.33-8.39-15.23A65.16,65.16,0,0,1,36.72,321.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.87,339.8c0,2.32-1.45,4.21-3.23,4.21s-3.24-1.89-3.24-4.21,1.45-4.21,3.24-4.21S43.87,337.47,43.87,339.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,347.84a1.91,1.91,0,0,1-1.62,2.1,2.18,2.18,0,0,1,0-4.21A1.91,1.91,0,0,1,40,347.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.92,341.48c-.9,2.75-2.48,4.69-3.54,4.34s-1.18-2.85-.28-5.59,2.49-4.68,3.54-4.34S30.82,338.74,29.92,341.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.47,157.63a20.69,20.69,0,0,1-14.82-6.22,21.71,21.71,0,0,1-6.22-15.47c.1-7.41,5.81-15.23,11.33-22.79.79-1.08,1.57-2.14,2.32-3.19A103.42,103.42,0,0,0,311,99.06l.14-.27.38,0a.59.59,0,0,1,.52.31A112,112,0,0,0,319,110.21c.91,1.27,1.85,2.54,2.79,3.82,5.13,6.94,10.43,14.11,10.68,21.91h0a21.07,21.07,0,0,1-5.94,15.26A20.83,20.83,0,0,1,311.47,157.63Zm0-57.44a106.91,106.91,0,0,1-6.58,10.35c-.75,1-1.53,2.12-2.32,3.2-5.43,7.43-11.05,15.12-11.14,22.22a20.68,20.68,0,0,0,5.93,14.74,19.85,19.85,0,0,0,28.49-.19A20.09,20.09,0,0,0,331.51,136h0c-.24-7.48-5.45-14.53-10.48-21.34-.95-1.29-1.89-2.56-2.8-3.84A118.71,118.71,0,0,1,311.47,100.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.45,100.24s-.5,1-1.45,2.6c-.23,1.79,0,5.1,1.91,11.15,3.71,11.74,4.91,25.15-1.32,29.94-5.32,4.1-13,5.3-18-.26a20.43,20.43,0,0,0,39.25-7.93c0-6.3-7.88-16.64-13.51-24.54A105.27,105.27,0,0,1,311.45,100.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,129.29c0,3.75-2.33,6.78-5.21,6.78s-5.22-3-5.22-6.78,2.34-6.78,5.22-6.78S323,125.55,323,129.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.72,142.25c0,1.87-1.16,3.39-2.6,3.39s-2.61-1.52-2.61-3.39,1.17-3.39,2.61-3.39S316.72,140.37,316.72,142.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5,132c-1.45,4.42-4,7.55-5.7,7s-1.9-4.59-.45-9,4-7.55,5.7-7S302,127.59,300.5,132Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.09,371.69a20.66,20.66,0,0,1-14.82-6.23A21.69,21.69,0,0,1,366.05,350c.1-7.42,5.81-15.23,11.33-22.79l2.32-3.2a101.74,101.74,0,0,0,6.86-10.89l.15-.27.38-.05a.58.58,0,0,1,.52.32,112.89,112.89,0,0,0,7.05,11.15c.91,1.27,1.85,2.54,2.79,3.82,5.13,6.94,10.43,14.11,10.68,21.9h0a21.14,21.14,0,0,1-21,21.7Zm0-57.44a108,108,0,0,1-6.58,10.34c-.75,1.06-1.53,2.13-2.32,3.21-5.43,7.43-11.05,15.12-11.14,22.21A20.7,20.7,0,0,0,373,364.76a19.85,19.85,0,0,0,28.49-.19A20.13,20.13,0,0,0,407.13,350h0c-.24-7.48-5.45-14.52-10.48-21.34-.95-1.28-1.89-2.56-2.8-3.83A117.23,117.23,0,0,1,387.09,314.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.07,314.3s-.5,1-1.45,2.59c-.23,1.79,0,5.11,1.91,11.15,3.71,11.74,4.91,25.16-1.32,29.95-5.32,4.09-13,5.3-18-.27a20.43,20.43,0,0,0,39.25-7.92c0-6.3-7.89-16.64-13.51-24.54A103.2,103.2,0,0,1,387.07,314.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.6,343.35c0,3.74-2.33,6.78-5.22,6.78s-5.21-3-5.21-6.78,2.33-6.78,5.21-6.78S398.6,339.61,398.6,343.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.34,356.3c0,1.87-1.17,3.39-2.61,3.39s-2.6-1.52-2.6-3.39,1.16-3.39,2.6-3.39S392.34,354.43,392.34,356.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.12,346.07c-1.45,4.42-4,7.55-5.7,7s-1.91-4.59-.46-9,4-7.55,5.71-7S377.57,341.65,376.12,346.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.51,117.35a32.22,32.22,0,0,1-23.07-9.68,33.88,33.88,0,0,1-9.68-24.07c.16-11.55,9.1-23.79,17.74-35.62,1.24-1.69,2.46-3.36,3.63-5a161.41,161.41,0,0,0,10.81-17.14.64.64,0,0,1,.57-.34h0a.64.64,0,0,1,.57.34,173.53,173.53,0,0,0,11.08,17.54c1.43,2,2.9,4,4.39,6,8,10.86,16.3,22.08,16.7,34.22A32.8,32.8,0,0,1,203,107.35,32.43,32.43,0,0,1,179.51,117.35Zm0-90.47A165.12,165.12,0,0,1,169,43.55c-1.18,1.65-2.4,3.33-3.64,5-8.55,11.71-17.39,23.81-17.55,35a32.8,32.8,0,0,0,9.4,23.35,31.45,31.45,0,0,0,45.12-.3,31.86,31.86,0,0,0,9-23c-.39-11.83-8.58-22.92-16.51-33.65-1.48-2-3-4-4.39-6A179,179,0,0,1,179.51,26.88Zm-.31-.58h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.48,27.56s-.78,1.51-2.28,4.07c-.36,2.81,0,8,3,17.5,5.83,18.43,7.71,39.48-2.07,47-8.35,6.42-20.42,8.32-28.21-.42a32.06,32.06,0,0,0,61.61-12.44c0-9.89-12.38-26.13-21.21-38.53A164.47,164.47,0,0,1,179.48,27.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.39,
    cy: 73.16,
    rx: 8.19,
    ry: 10.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.75,93.49c0,2.94-1.83,5.32-4.09,5.32s-4.09-2.38-4.09-5.32,1.83-5.32,4.09-5.32S187.75,90.55,187.75,93.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.29,77.42c-2.28,6.94-6.29,11.85-8.95,11s-3-7.21-.71-14.15,6.28-11.85,9-11S164.56,70.48,162.29,77.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--water-drop-1--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.89,152.61s-2.26,4.38-6.61,11.8c-1,8.16,0,23.24,8.71,50.76,16.9,53.44,22.36,114.51-6,136.33-24.23,18.64-59.22,24.13-81.81-1.22a93,93,0,0,0,178.68-36.07c0-28.69-35.9-75.77-61.51-111.73C261.12,174.08,249.89,152.61,249.89,152.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,412.08a92.4,92.4,0,0,1-66.21-27.81A97.12,97.12,0,0,1,156,315.16c.46-33.2,26.28-68.56,51.26-102.76,3.51-4.8,7.13-9.76,10.55-14.54a468,468,0,0,0,31.4-49.81.91.91,0,0,1,.81-.49h0a.94.94,0,0,1,.82.49A506.41,506.41,0,0,0,283,199c4.13,5.8,8.49,11.71,12.71,17.43,23.17,31.36,47.13,63.8,48.28,98.72a94.26,94.26,0,0,1-26.57,68.21A93.15,93.15,0,0,1,250,412.08Zm0-263.44a470.49,470.49,0,0,1-31.4,49.8c-3.42,4.79-7.05,9.75-10.55,14.55-24.89,34.07-50.62,69.3-51.07,102.18a96.17,96.17,0,0,0,27.52,68.4,92.16,92.16,0,0,0,132.23-.9A93.29,93.29,0,0,0,343,315.18c-1.14-34.61-25-66.91-48.08-98.16-4.22-5.72-8.59-11.63-12.73-17.44A508.87,508.87,0,0,1,250,148.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 312.55,
    cy: 312.02,
    rx: 26.99,
    ry: 17.21,
    transform: "matrix(0.08, -1, 1, 0.08, -22.17, 600.13)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.52
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.5,275.38c-18.62,31.4-48,42.93-53.82,34.57-6.18-8.35,7.72-29.3,21.82-53.6,14.6-24,26.36-46.22,36.66-44.79C240.26,212.66,244.19,244,225.5,275.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M311.27,359.61c-2.71,5.62-7.8,8.78-11.39,7.06s-4.3-7.68-1.59-13.3,7.8-8.79,11.38-7.06S314,354,311.27,359.61Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterdropBro);
export default __webpack_public_path__ + "static/media/Water drop-bro.ac36b2f21b456e09d0e2b3876f656453.svg";
export { ForwardRef as ReactComponent };